<template>
  <div class="baijin-report">
    <van-nav-bar title="評估結果" left-arrow :z-index="9999999" class="qjc-nav-bar"
      @click-left="$router.push('/user/history')">
      <van-image :src="require('@/assets/images/home.png')" slot="right" width="0.32rem" height="0.32rem"
        style="vertical-align: middle;" @click="$router.push('/')" />
    </van-nav-bar>

    <div class="result">

      <!--<div class="infomation-tip">
					<p>體型信息和生化指標信息僅限<span @click="lookMore">修改</span>一次</p>
				</div> -->
      <div class="branch_wrap">
        <div class="branch_score">
          <div class="branch_content">
            <div class="branch_item_title">
              健康評分
              <i @click="scoreTip1 = !scoreTip1" class="iconfont iconyiwen1 z_index9 qjc-relative">
                <div v-if="scoreTip1" class="score_tip_box qjc-bg-fff qjc-absolute">
                  <span
                    class="score_tip_text">米因以大數據為基礎，綜合個人的當前健康狀況、潛在疾病風險和未來健康風險進行整體評分，給出百分制的「健康分」，以求儘可能對整體健康進行量化評估，既可用於表示個人健康狀況，也可作為個人健康管理的目標和評價標準。
                    <br><span class="score_tip_span">對於個人而言，分數越高則相對越健康，健康分不適用於85歲以上的長者。</span></span>
                  <div class="arrow"></div>
                </div>
              </i>
            </div>
            <div class="score_info_top"
              :style="{ '--infoLeft': scoreVal > 3 ? scoreVal - 3 + '%' : scoreVal + 2 + '%' }">
              <div class="">
                <div class="">{{ base.age > 85 ? '健康分不適用於85歲以上的長者' : '你的健康評分' }}</div>
                <div class="score_info_top_info" v-if="base.age <= 85">
                  <span
                    :class="scoreVal <= 59 ? 'score_color3 score_val' : (scoreVal > 59 && scoreVal <= 89) ? 'score_color2 score_val' : 'score_color1 score_val'">{{
                      scoreVal }}</span><span
                    :class="scoreVal <= 59 ? 'score_color3 score_unit' : (scoreVal > 59 && scoreVal <= 89) ? 'score_color2 score_unit' : 'score_color1 score_unit'">
                    分({{ scoreVal <= 59 ? '欠佳' : (scoreVal > 59 && scoreVal <= 89) ? '良好' : scoreVal > 89 ? '優等' :
                      '' }})</span>
                  <img v-if="scoreVal <= 59" class="xiao_icon" src="@/assets/images/health_3.png" />
                  <img v-if="scoreVal > 59 && scoreVal <= 89" class="xiao_icon" src="@/assets/images/health_2.png" />
                  <img v-if="scoreVal > 89" class="xiao_icon" src="@/assets/images/health_1.png" />
                </div>
              </div>
              <div class="score_info_top_btn" v-if="base.age <= 85" @click="clickCheckModule('branch')">前往查看</div>
            </div>
            <div class="score_line">
              <div class="score_one_bg"></div>
              <div class="score_d1"></div>
              <div class="score_two_bg"></div>
              <div class="score_d2"></div>
              <div class="score_three_bg"></div>
              <div class="score_line_top">
                <div class="score_one" :style="{ width: (scoreVal <= 59 ? scoreVal + '%' : '59%') }"></div>
                <div v-if="scoreVal > 59" class="score_two"
                  :style="{ width: ((scoreVal > 59 && scoreVal <= 89) ? scoreVal - 59 + '%' : '30%') }"></div>
                <div v-if="scoreVal > 89" class="score_three"
                  :style="{ width: (scoreVal > 89 ? scoreVal - 89 + '%' : '11%') }"></div>
                <div
                  :class="scoreVal <= 59 ? 'score_circle3' : (scoreVal > 59 && scoreVal <= 89) ? 'score_circle2' : scoreVal > 89 ? 'score_circle1' : ''"
                  :style="{ left: scoreVal - 2 + '%' }"></div>
              </div>
            </div>
            <div class="score_text">健康分等級：100-90分以上視為「優等」；89-60分視作「良好」；59-1分視為「欠佳」。</div>
          </div>
        </div>
      </div>
      <div class="branch_wrap">
        <div class="branch_health branch_score">
          <div class="branch_content">
            <div class="branch_item_title">
              人群分類
            </div>
            <div class="branch_health_list">
              <div class="health-card HEA1" v-if="res.base.categ == 'HEA1'">
                <div class="card-label">妳屬於</div>
                <div class="card-value">健康人群</div>
              </div>
              <div class="health-card HEA2" v-else-if="res.base.categ == 'HEA2'">
                <div class="card-label">妳屬於</div>
                <div class="card-value">亞健康人群</div>
              </div>
              <div class="health-card HEA3" v-else-if="res.base.categ == 'HEA3'">
                <div class="card-label">妳屬於</div>
                <div class="card-value">醫療需求人群</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="person_wrap">
        <van-grid class="person qjc-bg-fff" :column-num="3" :border="false">
          <van-grid-item>

            <dl class="text_right">
              <dt>身高</dt>
              <dd class="qjc-c-primary"><b>{{ res.base.height }}cm</b></dd>
            </dl>
            <dl class="text_right">
              <dt>體重</dt>
              <dd class="qjc-c-primary"><b>{{ res.base.weight }}</b>kg</dd>
            </dl>
          </van-grid-item>
          <van-grid-item>
            <van-image width="1.84rem" height="5.5rem"
              :src="this.res.base.sex == 1 ? require('@/assets/images/man.png') : (this.res.base.sex == 2 ? require('@/assets/images/wuman.png') : null)" />
          </van-grid-item>
          <van-grid-item>
            <dl class="text_left">
              <dt>腰圍</dt>
              <dd class="qjc-c-primary"><b>{{ res.base.waist || '--' }}</b>cm</dd>
            </dl>
            <dl class="text_left">
              <dt>臀圍</dt>
              <dd class="qjc-c-primary"><b>{{ res.base.hip || '--' }}</b>cm</dd>
            </dl>

          </van-grid-item>
        </van-grid>
      </div>

      <div class="list">
        <!-- 模塊名列表 -->
        <van-sticky :z-index="1000" :offset-top="offsetTop" class="type-header-select">
          <ul class="list-title qjc-nowrap qjc-c-dark">
            <li v-if="modules.branch" @click="clickCheckModule('branch')" :class="{ active: active == 'branch' }">健康分
            </li>
            <li v-if="modules.total" @click="clickCheckModule('total')" :class="{ active: active == 'total' }">
              總體健康評估和生命預測</li>
            <li v-if="modules.bodily" @click="clickCheckModule('bodily')" :class="{ active: active == 'bodily' }">體型評估
            </li>
            <li v-if="modules.biom" @click="clickCheckModule('biom')" :class="{ active: active == 'biom' }">生化指標評估</li>
            <li v-if="modules.core" @click="clickCheckModule('core')" :class="{ active: active == 'core' }">潛在疾病風險評估
            </li>
            <li v-if="modules.health" @click="clickCheckModule('health')" :class="{ active: active == 'health' }">
              未來健康風險預測</li>
            <li v-if="modules.costs" @click="clickCheckModule('costs')" :class="{ active: active == 'costs' }">醫療費用預測
            </li>
            <li v-if="modules.illness" @click="clickCheckModule('illness')" :class="{ active: active == 'illness' }">
              未來疾病風險預測</li>
            <li v-if="modules.noSick" @click="clickCheckModule('noSick')" :class="{ active: active == 'noSick' }">不患病&增壽
            </li>
            <li v-if="modules.improve" @click="clickCheckModule('improve')" :class="{ active: active == 'improve' }">
              健康管理和改善方案</li>
          </ul>
        </van-sticky>

        <div class="type-content" @touchstart="touchStart($event)">
          <van-swipe @change="slide" :show-indicators="false" :loop="false" ref="swp">
            <van-swipe-item v-if="modules.branch" @touchmove="checkMove($event)">
              <!-- 健康分 -->
              <div v-if="active == 'branch' || nextActive == 'branch'" class="branch qjc-bg-fff">
                <div class="branch_score">
                  <div class="branch_content">
                    <div class="branch_item_title">
                      健康評分
                      <i @click="scoreTip = !scoreTip" class="iconfont iconyiwen1 z_index9 qjc-relative">
                        <div v-if="scoreTip" class="score_tip_box qjc-bg-fff qjc-absolute">
                          <span
                            class="score_tip_text">米因以大數據為基礎，綜合個人的當前健康狀況、潛在疾病風險和未來健康風險進行整體評分，給出百分制的「健康分」，以求儘可能對整體健康進行量化評估，既可用於表示個人健康狀況，也可作為個人健康管理的目標和評價標準。
                            <br><span class="score_tip_span">對於個人而言，分數越高則相對越健康，健康分不適用於85歲以上的長者。</span></span>
                          <div class="arrow"></div>
                        </div>
                      </i>
                    </div>
                    <div class="score_info"
                      :style="{ '--infoLeft': scoreVal > 3 ? scoreVal - 3 + '%' : scoreVal + 2 + '%' }">
                      <div class="" v-if="base.age <= 85">
                        你的健康評分
                        <span
                          :class="scoreVal <= 59 ? 'score_color3 score_val' : (scoreVal > 59 && scoreVal <= 89) ? 'score_color2 score_val' : 'score_color1 score_val'">{{
                            scoreVal }}</span><span
                          :class="scoreVal <= 59 ? 'score_color3 score_unit' : (scoreVal > 59 && scoreVal <= 89) ? 'score_color2 score_unit' : 'score_color1 score_unit'">
                          分({{ scoreVal <= 59 ? '欠佳' : (scoreVal > 59 && scoreVal <= 89) ? '良好' : scoreVal > 89 ? '優等' :
                            '' }})</span>
                        <img v-if="scoreVal <= 59" class="xiao_icon" src="@/assets/images/health_3.png" />
                        <img v-if="scoreVal > 59 && scoreVal <= 89" class="xiao_icon"
                          src="@/assets/images/health_2.png" />
                        <img v-if="scoreVal > 89" class="xiao_icon" src="@/assets/images/health_1.png" />
                      </div>
                      <div v-if="base.age > 85">健康分不適用於85歲以上的長者</div>
                    </div>
                    <div class="score_line">
                      <div class="score_one_bg"></div>
                      <div class="score_d1"></div>
                      <div class="score_two_bg"></div>
                      <div class="score_d2"></div>
                      <div class="score_three_bg"></div>
                      <div class="score_line_top">
                        <div class="score_one" :style="{ width: (scoreVal <= 59 ? scoreVal + '%' : '59%') }"></div>
                        <div v-if="scoreVal > 59" class="score_two"
                          :style="{ width: ((scoreVal > 59 && scoreVal <= 89) ? scoreVal - 59 + '%' : '30%') }"></div>
                        <div v-if="scoreVal > 89" class="score_three"
                          :style="{ width: (scoreVal > 89 ? scoreVal - 89 + '%' : '11%') }"></div>
                        <div
                          :class="scoreVal <= 59 ? 'score_circle3' : (scoreVal > 59 && scoreVal <= 89) ? 'score_circle2' : scoreVal > 89 ? 'score_circle1' : ''"
                          :style="{ left: scoreVal - 2 + '%' }"></div>
                      </div>
                    </div>
                    <div class="score_text">健康分等級：100-90分以上視為「優等」；89-60分視作「良好」；59-1分視為「欠佳」。</div>
                  </div>
                </div>
                <div class="branch_course">
                  <div class="branch_header">健康是人生的動態歷程</div>
                  <div class="branch_content">
                    <div class="branch_type_list">
                      <div class="branch_type_item">健康</div>
                      <div class="branch_type_jt"></div>
                      <div class="branch_type_item">亞健康</div>
                      <div class="branch_type_jt"></div>
                      <div class="branch_type_item">患病者</div>
                    </div>
                    <div class="branch_type_item branch_100">過程是可逆的</div>
                    <div class="branch_type_text">因不良生活習慣導致患病的慢病患者，在適當的醫療介入與生活習慣改善後，完全有可能逐漸康復、不再復發。</div>
                  </div>
                </div>
                <div class="branch_course">
                  <div class="branch_header">影響個人健康的因素</div>
                  <div class="branch_content">
                    <div class="branch_type_list">
                      <div class="branch_type_c">基因遺傳</div>
                      <div class="branch_type_c">生活環境</div>
                      <div class="branch_type_c">生活習慣</div>
                      <div class="branch_type_c">醫療支持</div>
                      <div class="branch_type_c">特殊因素</div>
                    </div>
                  </div>
                </div>
                <div class="branch_course">
                  <div class="branch_header">不同人群影響健康分的因素</div>
                  <div class="branch_content">
                    <div class="branch_yl">
                      <span>醫療需求人群</span>
                      同一或不同疾病間都有輕重程度之別，在醫療科技與健康意識進步下，疾病的可控度與可愈度已進步很多，疾病未必會造成身心失衡或影響活力，因此患病者也有可能在平穩控制病情和保持良好生活習慣的情況下，獲得比較高的健康分。
                    </div>
                    <div class="branch_yjk">
                      <span>亞健康人群</span>
                      往往在不良生活習慣的影響下，身體已有許多潛在疾病但尚未表露，表面看似僅是忙碌勞累，實則是在透支生命與健康。這種情況下往往只需要一兩次急症發作，便會全面引爆潛藏的健康危機，導致個人健康狀況的迅速惡化。如果你認為自己較為健康，但卻獲得了不理想的健康分結果，還請你提高警惕，更多關愛自身。
                    </div>
                    <div class="sangao_text">在人群大數據的維度中，健康分與各類疾病、重大傷病、門診次數、醫療費用、住院次數、住院天數甚至死亡率等均有高度相關性。</div>
                  </div>
                </div>
                <div class="branch_score">
                  <div class="branch_content">
                    <div class="branch_sangao_title">健康分與三高疾病的相關性</div>
                    <div class="sel_cell">
                      <select name="sangao" v-model="sangaoVal" class="select_style">
                        <option value="1">高血壓</option>
                        <option value="2">高血脂</option>
                        <option value="3">高血糖</option>
                      </select>
                    </div>
                    <div
                      :class="sangaoVal == '1' ? 'dl_bg' : sangaoVal == '2' ? 'dl_bg2' : sangaoVal == '3' ? 'dl_bg3' : ''">
                      <div class="dl_bg_line" :style="{ left: 100 - scoreVal + 10 + '%' }">
                        <div class="dl_bg_tip">你的位置</div>
                      </div>
                    </div>
                    <div class="dl_catg">
                      <div class="dl_catg_wm">女性</div>
                      <div class="dl_catg_m">男性</div>
                    </div>
                  </div>
                </div>
                <div class="branch_score">
                  <div class="branch_content">
                    <div class="branch_dl_title">健康分與其餘常見慢性疾病的相關性</div>
                    <div class="sel_cell">
                      <select name="dlVal" v-model="dlVal" class="select_style">
                        <option value="1">癌症</option>
                        <option value="2">肝炎、肝硬化</option>
                        <option value="3">關節炎</option>
                        <option value="4">甲狀腺異常</option>
                        <option value="5">腦中風</option>
                        <option value="6">貧血</option>
                        <option value="7">氣喘</option>
                        <option value="8">腎臟病、結石</option>
                        <option value="9">失眠</option>
                        <option value="10">疼痛</option>
                        <option value="11">消化性潰瘍</option>
                        <option value="12">心臟病</option>
                        <option value="13">copd</option>
                      </select>
                    </div>
                    <div :class="dlVal == '1' ? 'dl_bg4' : dlVal == '2' ? 'dl_bg5' : dlVal == '3' ? 'dl_bg6' : dlVal == '4' ? 'dl_bg7' : dlVal == '5' ? 'dl_bg8'
                      : dlVal == '6' ? 'dl_bg9' : dlVal == '7' ? 'dl_bg10' : dlVal == '8' ? 'dl_bg11' : dlVal == '9' ? 'dl_bg12' : dlVal == '10' ? 'dl_bg13' : dlVal == '11' ? 'dl_bg15'
                        : dlVal == '12' ? 'dl_bg15' : dlVal == '13' ? 'dl_bg16' : ''">
                      <div class="dl_bg_line" :style="{ left: 100 - scoreVal + 10 + '%' }">
                        <div class="dl_bg_tip">你的位置</div>
                      </div>
                    </div>
                    <div class="dl_catg">
                      <div class="dl_catg_wm">女性</div>
                      <div class="dl_catg_m">男性</div>
                    </div>
                  </div>
                </div>
                <div class="branch_score">
                  <div class="branch_content">
                    <div class="branch_sangao_title">健康分與醫療利用的相關性</div>
                    <div class="sel_cell">
                      <select name="medical" v-model="medicalVal" class="select_style">
                        <option value="1">平均門診次數</option>
                        <option value="2">平均醫療費用</option>
                        <option value="3">平均住院次數</option>
                        <option value="4">平均住院天數</option>
                      </select>
                    </div>
                    <div
                      :class="medicalVal == '1' ? 'medical_dl_bg' : medicalVal == '2' ? 'medical_dl_bg2' : medicalVal == '3' ? 'medical_dl_bg3' : medicalVal == '4' ? 'medical_dl_bg4' : ''">
                      <div class="medical_dl_bg_line" :style="{ left: 100 - scoreVal + 3 + '%' }">
                        <div class="dl_bg_tip">你的位置</div>
                      </div>
                    </div>
                    <div class="dl_catg">
                      <div class="dl_catg_wm">女性</div>
                      <div class="dl_catg_m">男性</div>
                    </div>
                  </div>
                </div>
                <div class="branch_score">
                  <div class="branch_content">
                    <div class="branch_sangao_title">健康分與重大傷病的相關性</div>
                    <div class="sel_cell">
                      <select name="injuryVal" v-model="injuryVal" class="select_style">
                        <option value="1">重大傷病率</option>
                        <option value="2">死亡率</option>
                      </select>
                    </div>
                    <div :class="injuryVal == '1' ? 'injury_dl_bg' : injuryVal == '2' ? 'injury_dl_bg2' : ''">
                      <div class="medical_dl_bg_line" :style="{ left: 100 - scoreVal + 4 + '%' }">
                        <div class="dl_bg_tip">你的位置</div>
                      </div>
                    </div>
                    <div class="dl_catg">
                      <div class="dl_catg_wm">女性</div>
                      <div class="dl_catg_m">男性</div>
                      <div class="dl_catg_h">合計</div>
                    </div>
                  </div>
                </div>
              </div>
            </van-swipe-item>
            <van-swipe-item v-if="modules.biom" @touchmove="checkMove($event)">
              <!-- 生化指標評估 -->
              <div v-if="active == 'biom' || nextActive == 'biom'" class="biom qjc-texta-l qjc-bg-fff">
                <div class="tip_p">「生化檢驗」是檢測血液中的各種離子、糖類、脂類、蛋白質以及各種酶、激素和機體的多種代謝產物的含量，作為個人健康的「參照物」來推測身體健康程度。</div>
                <div class="tip_p">臨床上生化檢驗的目的在於疾病的診斷、追蹤治療效果、病情預後指標及疾病的篩檢。健檢時生化檢驗的目的在於找出未被發現的疾病，以達早期發現；以便早期治療，提早療效。</div>
                <div class="tip_p">生化檢查除臨牀與健檢在處理「既病」的相關應用外，我們更是可以利用相關生化檢查數據與生活習性問卷，發現可能的「未病」與「欲病」，以阻斷疾病的發生。</div>
                <div class="tip_p">大部分生化檢驗結果正常與否，均會參考其是否落在正常值範圍而判定。若檢驗數據異常，表示某種疾病存在的機率較大；反之檢驗數據正常，表示某種疾病存在的機率較低。</div>
                <div class="tip_p">
                  有時候，單一的檢驗值雖在正常範圍，但受其他健康條件的影響，或許有很大的機率無法有效的反映該檢驗的功能，而表現失效，也就是説任一檢驗反應在疾病上，都有「假陽性」與「假陰性」的問題。為避免單一檢驗的失效，我們利用臨牀數據庫，綜合各項檢驗與其他條件，建立疾病預測模型，再以你的生化檢驗值的結果，估算個人未來各類慢性病、癌症、重大病症、失能或死亡發生的機率，這是一般健檢報告無法表現與提供的。
                </div>
                <div class="tip_p">生化檢驗結果反應了個人健康程度，但是健康程度又與年齡、性別有關，所以多數生化檢驗值正常範圍應隨年齡、性別不同而變化，因此我們也提供同族群（People Like
                  Me--與你相似的人群--與你同性別同年齡段的人群）的各項檢驗值的平均數，以找出你需維持或改善的項目與目標，作為健康管理的參考依據。現代社會生活節奏快壓力大，不健康的生活方式愈發普遍，因而同族群平均值也會受到相應的影響，例如對於中老年人群，血糖、膽固醇等四高相關指標的同族群平均值有可能顯著偏高，甚至超出臨牀標準範圍，這種情況反而更加説明定期檢查與健康管理的重要性。我們希望你能結合「臨牀標準」與「同族群平均值」兩個維度，更加全面、客觀的掌握自身的健康狀況。
                </div>
                <div class="tip_p">懷孕會造成血壓略微升高，這是正常的現象。另外，孕產期女性需要更加嚴格的監控血糖變化，請多加註意。</div>
                <p>同族群(PLM,People Like Me)：與你相似(同性別同年齡段的人群)</p>
                <div class="costs_top bomi_btn_box">
                  <div class="">生化指標評估</div>
                  <div class="bomi_btn_cell">
                    <div :class="bomiBtn == 1 ? 'bomi_v_btn bomi_btn_active' : 'bomi_v_btn'" @click="bomiBtn = 1">
                      與臨牀標準比較</div>
                    <div :class="bomiBtn == 2 ? 'bomi_g_btn bomi_btn_active' : 'bomi_g_btn'" v-if="hasGroup"
                      @click="bomiBtn = 2">與同族群比較</div>
                  </div>
                </div>
                <div class="bomi_top_cell">
                  <div class="bomi_title">血常規檢查</div>
                  <div class="bomi_res">檢查結果</div>
                  <div class="bomi_v bomi_lc" v-if="bomiBtn == 1">臨牀標準範圍</div>
                  <div class="bomi_v bomi_btn_v" v-if="bomiBtn == 1">結果</div>
                  <div class="bomi_v bomi_lc" v-if="bomiBtn == 2">同族群平均值</div>
                  <div class="bomi_group bomi_btn_v" v-if="bomiBtn == 2">結果</div>
                </div>
                <div class="bomi_item cbc_cell" v-for="(cbc, index) in biomData.CBC" :key="cbc.item">
                  <div class="bomi_item_title">{{ biomData.CBC[index].item_d }}</div>
                  <div class="bomi_item_res">{{ biomData.CBC[index].value }}<span>{{ biomData.CBC[index].unit }}</span>
                  </div>
                  <div class="bomi_item_res" v-if="bomiBtn == 1">{{ biomData.CBC[index].range }}
                    {{ biomData.CBC[index].unit }}</div>
                  <div v-if="bomiBtn == 1"
                    :class="biomData.CBC[index].group_n == '異常' ? 'bomi_item_v c-high' : 'bomi_item_v'">
                    {{ biomData.CBC[index].group_n }}</div>
                  <div class="bomi_item_res" v-if="bomiBtn == 2">{{ biomData.CBC[index].p50 }}
                    {{ biomData.CBC[index].unit }}</div>
                  <div v-if="bomiBtn == 2" :class="getBiomClass(biomData.CBC[index])">
                    {{ biomData.CBC[index].group_p }}</div>
                </div>
                <div class="bomi_top_cell">
                  <div class="bomi_title">血糖檢查</div>
                </div>
                <div class="bomi_item" v-for="(item, index) in biomData.bloodGlucose" :key="item.item">
                  <div class="bomi_item_title">{{ biomData.bloodGlucose[index].item_d }}</div>
                  <div class="bomi_item_res">{{ biomData.bloodGlucose[index].value }}<span>{{
                    biomData.bloodGlucose[index].unit }}</span></div>
                  <div class="bomi_item_res" v-if="bomiBtn == 1">{{ biomData.bloodGlucose[index].range }}
                    {{ biomData.bloodGlucose[index].unit }}</div>
                  <div v-if="bomiBtn == 1"
                    :class="biomData.bloodGlucose[index].group_n == '異常' ? 'bomi_item_v c-high' : 'bomi_item_v'">
                    {{ biomData.bloodGlucose[index].group_n }}</div>
                  <div class="bomi_item_res" v-if="bomiBtn == 2">{{ biomData.bloodGlucose[index].p50 }}
                    {{ biomData.bloodGlucose[index].unit }}</div>
                  <div v-if="bomiBtn == 2" :class="getBiomClass(biomData.bloodGlucose[index])">
                    {{ biomData.bloodGlucose[index].group_p }}</div>
                </div>
                <div class="bomi_top_cell">
                  <div class="bomi_title">血脂肪檢查</div>
                </div>
                <div class="bomi_item" v-for="(item, index) in biomData.bloodLipids" :key="item.item">
                  <div class="bomi_item_title">{{ biomData.bloodLipids[index].item_d }}</div>
                  <div class="bomi_item_res">{{ biomData.bloodLipids[index].value }}<span>{{
                    biomData.bloodLipids[index].unit }}</span></div>
                  <div class="bomi_item_res" v-if="bomiBtn == 1">{{ biomData.bloodLipids[index].range }}
                    {{ biomData.bloodLipids[index].unit }}</div>
                  <div v-if="bomiBtn == 1"
                    :class="biomData.bloodLipids[index].group_n == '異常' ? 'bomi_item_v c-high' : 'bomi_item_v'">
                    {{ biomData.bloodLipids[index].group_n }}</div>
                  <div class="bomi_item_res" v-if="bomiBtn == 2">{{ biomData.bloodLipids[index].p50 }}
                    {{ biomData.bloodLipids[index].unit }}</div>
                  <div v-if="bomiBtn == 2" :class="getBiomClass(biomData.bloodLipids[index])">
                    {{ biomData.bloodLipids[index].group_p }}</div>
                </div>
                <div class="bomi_top_cell">
                  <div class="bomi_title">肝膽功能檢查</div>
                </div>
                <div class="bomi_item" v-for="(item, index) in biomData.ALT" :key="item.item">
                  <div class="bomi_item_title">{{ biomData.ALT[index].item_d }}</div>
                  <div class="bomi_item_res">{{ biomData.ALT[index].value }}<span>{{ biomData.ALT[index].unit }}</span>
                  </div>
                  <div class="bomi_item_res" v-if="bomiBtn == 1">{{ biomData.ALT[index].range }}
                    {{ biomData.ALT[index].unit }}</div>
                  <div v-if="bomiBtn == 1"
                    :class="biomData.ALT[index].group_n == '異常' ? 'bomi_item_v c-high' : 'bomi_item_v'">
                    {{ biomData.ALT[index].group_n }}</div>
                  <div class="bomi_item_res" v-if="bomiBtn == 2">{{ biomData.ALT[index].p50 }}
                    {{ biomData.ALT[index].unit }}</div>
                  <div v-if="bomiBtn == 2" :class="getBiomClass(biomData.ALT[index])">
                    {{ biomData.ALT[index].group_p }}</div>
                </div>
                <div class="bomi_top_cell">
                  <div class="bomi_title">腎功能檢查</div>
                </div>
                <div class="bomi_item" v-for="(item, index) in biomData.renalFunc" :key="item.item">
                  <div class="bomi_item_title">{{ biomData.renalFunc[index].item_d }}</div>
                  <div class="bomi_item_res">{{ biomData.renalFunc[index].value }}<span>{{
                    biomData.renalFunc[index].unit
                      }}</span></div>
                  <div class="bomi_item_res" v-if="bomiBtn == 1">{{ biomData.renalFunc[index].range }}
                    {{ biomData.renalFunc[index].unit }}</div>
                  <div v-if="bomiBtn == 1"
                    :class="biomData.renalFunc[index].group_n == '異常' ? 'bomi_item_v c-high' : 'bomi_item_v'">
                    {{ biomData.renalFunc[index].group_n }}</div>
                  <div class="bomi_item_res" v-if="bomiBtn == 2">{{ biomData.renalFunc[index].p50 }}
                    {{ biomData.renalFunc[index].unit }}</div>
                  <div v-if="bomiBtn == 2" :class="getBiomClass(biomData.renalFunc[index])">
                    {{ biomData.renalFunc[index].group_p }}</div>
                </div>

              </div>
            </van-swipe-item>
            <van-swipe-item v-if="modules.core" @touchmove="checkMove($event)">
              <!-- 生化指標評估 -->
              <div v-if="active == 'core' || nextActive == 'core'" class="core qjc-texta-l qjc-bg-fff">
                <div v-if="res.m15">
                  <!-- <h3 class="chart-t qjc-fts-28 qjc-c-dark">常見疾病風險倍率如下表：</h3> -->
                  <div class="costs_top margin-top-48">潛在疾病風險評估</div>
                  <div class="tip_p">
                    為預測健康人群「未病」與亞健康人群「欲病」的發生、及醫療需求人群「既病」病情的演變，團隊利用海量健康與臨牀資料，透過大數據分析建立疾病預測模式，將個人生活習性問卷、體態評估、生化檢驗結果評估等健康影響因子等資料，評估與預測個人可能罹患各項疾病的風險，並透過同族群People
                    Like Me模式，得到個人罹病的風險倍率，若倍率高於1愈多，表示個人罹患該疾病可能風險愈高。</div>
                  <div class="tip_p">罹病的風險倍率代表着健康管理與疾病管理的迫切性，透過有效且積極的管理，將能有效的降低風險倍率，以阻斷「未病/欲病」的發生，或防止「既病」的進一步惡化。</div>
                  <div class="tip_p">因此，建議當倍率大於1時，宜針對高風險疾病每半年追蹤檢查評估一次；當倍率大於2時，宜針對高風險疾病做進一步的檢查或每半年追蹤檢查評估一次。</div>
                  <div class="biom-chart" key="biom-chart">

                  </div>
                  <div class="biom-chart_bottom">建議你進一步檢查或每半年追蹤檢查評估</div>
                  <div class="biom-chart_bottom2">建議你每半年追蹤檢查評估</div>
                </div>
              </div>
            </van-swipe-item>
            <van-swipe-item v-if="modules.health" @touchmove="checkMove($event)">
              <!-- 未來健康風險預測 -->
              <div v-if="active == 'health' || nextActive == 'health'" class="health qjc-bg-fff">
                <!-- 健康者 -->
                <div v-if="res.base.categ == 'HEA1'" class="health1 qjc-texta-l">
                  <p>
                    測量綜合生理年齡RealAge，目的是在希望你能體會個人健康現況，可以更注重個人健康促進，讓你未來能表現的更為年輕有活力。錯誤或不好的生活習慣，會讓人身體生理機能的年齡比實際歲數老化，並增加罹病幾率和死亡幾率。
                  </p>
                  <p>
                    綜合生理年齡RealAge，是經研究分析海量的健康數據庫，依照個人的健康危險因子（如：生活習慣、運動飲食、….等）的多寡與影響程度，分別給予正負分來計算，換句話説：RealAge＝實際年齡±影響健康危險因子之加總值。
                  </p>
                  <p>透過綜合生理年齡RealAge的檢測，瞭解健康危險因子對自己身體生理的影響程度，未來能加強良好飲食、運動、生活習慣，確實做好健康管理、預防保健與養生，以延緩老化、降低罹病與失能幾率。</p>
                  <div class="qjc-texta-c">
                    <dl>
                      <dd class="qjc-c-primary">
                        <b>{{ res.base.age }}</b>歲
                      </dd>
                      <dt>你的實際年齡</dt>
                    </dl>
                    <dl>
                      <dd class="qjc-c-primary">
                        <b>{{ res.m02.realage }}</b>歲
                      </dd>
                      <dt>你的綜合生理年齡 Real Age</dt>
                    </dl>
                  </div>
                  <p>綜合生理年齡是從醫學、生物學的角度來衡量的年齡，表示身體的成長、成熟或衰老的程度。米因在千萬人口的醫療健康大數據庫基礎上，挖掘出綜合生理年齡所對應的關鍵指標，為你提供詳細、準確的大數據分析結果。
                  </p>
                </div>
                <!-- 亞健康 -->
                <div class="three_list" v-else-if="res.base.categ == 'HEA2'">
                  <div class="costs_top">四高風險倍率</div>
                  <div class="tip_p_wrap">
                    <div class="tip_p">心血管疾病是人類頭號殺手，每年因心血管疾病死亡的人數佔總死亡人數的30%以上。</div>
                    <div class="tip_p">心血管疾病包括心臟病、中風和血管疾病等。中國的中風發病率是西方國家的4倍。</div>
                    <div class="tip_p">由心血管疾病引發的死亡約80%發生在中低收入家庭，且多發生在人的壯年期。</div>
                    <div class="tip_p">導致心血管疾病的主要因素就是“四高”疾病：高血壓、糖尿病、高膽固醇(高血脂)和高尿酸(痛風)。</div>
                    <div class="tip_p">“四高”疾病可能引發各種嚴重的併發症，除了心血管疾病以外，常見的有腎臟損害、眼底損害等，這些併發症都可能危及生命。</div>
                    <div class="tip_p">為了身體健康和生命安全，應經常檢測血壓、血糖，儘量做到“早發現、早介入、早阻斷”，在“四高”疾病實際發生以前降低相關風險，及時阻斷或延緩相關疾病和併發症的發生。
                    </div>
                  </div>


                  <ul>
                    <li v-for="(item, index) in threeHighsClassify()" :key="index">
                      <h3 class="qjc-texta-l qjc-c-dark qjc-fts-32">{{ item.devg }}</h3>
                      <dl>
                        <dd class="qjc-c-primary qjc-ftw-b">
                          <span :style="{ color: item.sick && item.sick == 1 ? '#FF3131' : '' }">{{ item.sick &&
                            item.sick
                            == 1 ? '根據你填寫的問卷內容，你已患病' : item.rate == 0.1 && item.tag ? item.tag + '倍' : item.rate +
                              '倍' }}</span>
                        </dd>
                        <dt class="qjc-ftw-b">{{ item.sick && item.sick == 1 ? '' : '患病風險是同類族群平均患病風險的' }}</dt>
                      </dl>
                      <p class="qjc-texta-l">
                        <span class="qjc-c-dark">主要症狀：</span>{{ item.desc }}
                      </p>
                      <p class="qjc-texta-l"><span class="qjc-c-dark qjc-ftw-b">注：</span>同族群（PLM，People Like
                        Me）:與你相似的人群--與你同性別同年齡段的人群。</p>
                    </li>
                  </ul>

                </div>

              </div>
            </van-swipe-item>

            <van-swipe-item v-if="modules.total" @touchmove="checkMove($event)">
              <!-- 總體健康評估和生命預測 -->
              <div v-if="active == 'total' || nextActive == 'total'" class="total qjc-bg-fff">

                <div class="total_title">生命曲線圖</div>
                <div class="total-chart" key="total-chart">

                </div>
                <div class="total_item" v-if="res.m01.lift_rates_90">
                  <div class="total_item_cell">
                    <div class="total_item_title">九十歲概率</div>
                    <div class="total_item_val">{{ res.m01.lift_rates_90 ? res.m01.lift_rates_90 : '--' }}<span>%</span>
                    </div>
                  </div>
                  <div class="total_item_text">如果你能努力於健康促進，仍有相當的機會活超過90歲，因生病或卧牀而失能的比例也會隨之降低。</div>
                </div>
                <div class="total_item">
                  <div class="total_item_cell">
                    <div class="total_item_title">百歲概率</div>
                    <div class="total_item_val">{{ res.m01.lift_rates_100 ? res.m01.lift_rates_100 : 0 }}<span>%</span>
                    </div>
                  </div>
                  <div class="total_item_text">不生病或延緩病情，降低疾病對健康的影響，必須透過健康促進與健康管理，才能「防未病、斷欲病、緩既病」，進而有效的「延長健康的餘命」。</div>
                </div>
                <div class="total_item">
                  <div class="total_item_cell">
                    <div class="total_item_title">失能的平均概率</div>
                    <div class="total_item_val">{{ res.m01.lost_ability }}<span>%</span></div>
                  </div>
                  <div class="total_item_text">
                    現時科技與生活環境之下，人類的壽限約120歲；但人類平均壽命約在80歲左右，距離120歲的壽限還有很大的進步空間。現在醫療科技進步，人類普遍面臨的是「生命」延長了，但因為不健康而生病，將導致不便或卧牀，影響生活與生命品質，造成痛苦苟延殘喘的時間也可能跟着延長。我們將可能影響生活品質的時間當成「失能時間」。
                  </div>
                </div>
                <!-- <div class="hint qjc-texta-l">
									<p><span class="qjc-c-primary">友情提示：</span>現時科技與生活環境之下，人類的壽限約120歲；但人類平均壽命約在80歲左右，距離120歲的壽限還有很大的進步空間。現在醫療科技進步，人類普遍面臨的是“生命”延長了，但因為不健康而生病，將導致不便或卧牀，影響生活與生命品質，造成痛苦苟延殘喘的時間也可能跟着延長。我們將可能影響生活品質的時間當成“失能時間”。</p>
									<p>不生病或延緩病情，降低疾病對健康的影響，必須透過健康促進與健康管理，才能“防未病、斷欲病、緩既病”，進而有效的“延長健康的餘命”。</p>
								</div> -->
              </div>
            </van-swipe-item>
            <van-swipe-item v-if="modules.bodily" @touchmove="checkMove($event)">
              <!-- 體型評估 -->
              <div v-if="active == 'bodily' || nextActive == 'bodily'" class="bodily">
                <div class="res">
                  <div class="">
                    <div class="tip_p">
                      體型（如身體質量指數BMI、腰臀比WHR、體脂率FAT等）數據常是健康與否的最重要指標之一，體型數據失衡時，往往是內在核心生化指標發生重要改變的外在表現，常是慢性病發生的先兆。臨牀研究指出如肥胖或過重易引起四高疾患（高血壓、高血脂、糖尿病）等長期慢性疾病，因此日常依據體型（即身高、體重、腰圍、臀圍等）評估的結果，進行個人體型的管理，對健康管理是最簡單易行且助益頗大。
                    </div>
                    <div class="tip_p">
                      米因依據逾2500萬華人的健康大數據，評估你的體型，與臨牀標準相互比較下，找出你的體型需維持或改善的項目（含BMI、腰臀比和體脂率）與目標，並以此為根據找出健康管理（如飲食熱量、運動等）的目標與方法。
                    </div>
                    <div class="tip_p">透過體型評估，可以知道身體的警訊在哪，進而瞭解未來可能罹患慢性疾病的風險，加強個人健康意識，會更有動力依據團隊健康管理目標，進行相關的健康促進作為。</div>
                  </div>
                  <h4 class="qjc-c-dark qjc-texta-l qjc-ftw-b qjc-fts-28">與同類族群比，你的體脂率<span
                      class="res-bfr qjc-c-primary">{{
                        ['1', '4', '7'].indexOf(res.m05.body_g[0]) != -1 ? '偏低' : (['2', '5',
                          '8'].indexOf(res.m05.body_g[0]) != -1 ? '適中' : (['3', '6',
                            '9'].indexOf(res.m05.body_g[0]) != -1 ? '偏高' : '未知'))
                      }}</span>，BMI<span class="qjc-c-primary">{{ res.m05.bmi_g[1] }}</span>，在同類族群中屬於<span
                      class="qjc-c-primary">{{ res.m05.body_g[1] }}</span></h4>
                  <table class="qjc-wid-100 qjc-bg-fff" border="0" cellpadding="0" cellspacing="0">
                    <thead>
                      <th>
                        <span class="BFR-t">體脂率(%)</span>
                        <span class="BMI-t">BMI</span>
                      </th>
                      <th :class="{ 'qjc-c-primary qjc-ftw-b': res.m05.bmi_g[1] == '偏低' }">偏低</th>
                      <th :class="{ 'qjc-c-primary qjc-ftw-b': res.m05.bmi_g[1] == '適中' }">適中</th>
                      <th :class="{ 'qjc-c-primary qjc-ftw-b': res.m05.bmi_g[1] == '偏高' }">偏高</th>
                    </thead>
                    <tr>
                      <td :class="{ 'qjc-c-primary qjc-ftw-b': ['1', '4', '7'].indexOf(res.m05.body_g[0]) != -1 }">偏低
                      </td>
                      <td>
                        <van-image width="0.5rem" height="1.06rem"
                          :src="res.m05.body_g[0] == '1' ? require('@/assets/images/xiaoshou--blue.png') : require('@/assets/images/xiaoshou.png')" />
                        <span :class="{ 'qjc-c-primary qjc-ftw-b': res.m05.body_g[0] == '1' }"
                          class="img-hint">消瘦</span>
                      </td>
                      <td>
                        <van-image width="0.5rem" height="1.06rem"
                          :src="res.m05.body_g[0] == '4' ? require('@/assets/images/jingshi--blue.png') : require('@/assets/images/jingshi.png')" />
                        <span :class="{ 'qjc-c-primary qjc-ftw-b': res.m05.body_g[0] == '4' }"
                          class="img-hint">精實</span>
                      </td>
                      <td>
                        <van-image width="0.5rem" height="1.06rem"
                          :src="res.m05.body_g[0] == '7' ? require('@/assets/images/jianmei--blue.png') : require('@/assets/images/jianmei.png')" />
                        <span :class="{ 'qjc-c-primary qjc-ftw-b': res.m05.body_g[0] == '7' }"
                          class="img-hint">健美</span>
                      </td>
                    </tr>
                    <tr>
                      <td :class="{ 'qjc-c-primary qjc-ftw-b': ['2', '5', '8'].indexOf(res.m05.body_g[0]) != -1 }">適中
                      </td>
                      <td>
                        <van-image width="0.5rem" height="1.06rem"
                          :src="res.m05.body_g[0] == '2' ? require('@/assets/images/miaotiao--blue.png') : require('@/assets/images/miaotiao.png')" />
                        <span :class="{ 'qjc-c-primary qjc-ftw-b': res.m05.body_g[0] == '2' }"
                          class="img-hint">苗條</span>
                      </td>
                      <td>
                        <van-image width="0.5rem" height="1.06rem"
                          :src="res.m05.body_g[0] == '5' ? require('@/assets/images/shizhong--blue.png') : require('@/assets/images/shizhong.png')" />
                        <span :class="{ 'qjc-c-primary qjc-ftw-b': res.m05.body_g[0] == '5' }"
                          class="img-hint">適中</span>
                      </td>
                      <td>
                        <van-image width="0.5rem" height="1.06rem"
                          :src="res.m05.body_g[0] == '8' ? require('@/assets/images/zhuangshuo--blue.png') : require('@/assets/images/zhuangshuo.png')" />
                        <span :class="{ 'qjc-c-primary qjc-ftw-b': res.m05.body_g[0] == '8' }"
                          class="img-hint">壯碩</span>
                      </td>
                    </tr>
                    <tr>
                      <td :class="{ 'qjc-c-primary qjc-ftw-b': ['3', '6', '9'].indexOf(res.m05.body_g[0]) != -1 }">偏高
                      </td>
                      <td>
                        <van-image width="0.5rem" height="1.06rem"
                          :src="res.m05.body_g[0] == '3' ? require('@/assets/images/yinxingfeipang--blue.png') : require('@/assets/images/yinxingfeipang.png')" />
                        <span :class="{ 'qjc-c-primary qjc-ftw-b': res.m05.body_g[0] == '3' }"
                          class="img-hint">隱性肥胖</span>
                      </td>
                      <td>
                        <van-image width="0.5rem" height="1.06rem"
                          :src="res.m05.body_g[0] == '6' ? require('@/assets/images/yinxingfeipang2--blue.png') : require('@/assets/images/yinxingfeipang2.png')" />
                        <span :class="{ 'qjc-c-primary qjc-ftw-b': res.m05.body_g[0] == '6' }"
                          class="img-hint">隱性肥胖</span>
                      </td>
                      <td>
                        <van-image width="0.5rem" height="1.06rem"
                          :src="res.m05.body_g[0] == '9' ? require('@/assets/images/feipang--blue.png') : require('@/assets/images/feipang.png')" />
                        <span :class="{ 'qjc-c-primary qjc-ftw-b': res.m05.body_g[0] == '9' }"
                          class="img-hint">肥胖</span>
                      </td>
                    </tr>
                  </table>
                  <h4 class="qjc-c-dark qjc-texta-l qjc-ftw-b qjc-fts-28">{{ res.m05.body_g[2] }}</h4>
                </div>
                <div class="targets qjc-texta-l qjc-ftw-b">
                  <h4 class="qjc-c-dark qjc-fts-28">你的各項指標</h4>
                  <div class="body_item">
                    <div class="body_item_title">BMI</div>
                    <div class="body_item_val">你的BMI：<span>{{ res.base && res.base.bmi }}</span></div>
                    <div class="body_echat">
                      <div class="body_echat_title">與臨牀標準比</div>
                      <div class="line ">
                        <div class="body_echat_val" :style="{ 'left': bmiLeft > 62 ? 62 + '%' : bmiLeft - 12 + '%' }">
                          {{ res.base && res.base.bmi }}<span
                            :class="bmi_n[1] == '正常' ? 'body_val_zhong' : 'body_val_gao'">{{ bmi_n[1] }}</span></div>
                        <div class="biaoqian_box" :style="{ 'left': bmiLeft - 3 + '%' }">
                          <img class="biaoqian" v-if="base.bmi < bmiVal[0]" src="@/assets/images/biaoqian2.png" alt="">
                          <img class="biaoqian" v-if="base.bmi >= bmiVal[0] && base.bmi <= bmiVal[1]"
                            src="@/assets/images/biaoqian3.png" alt="">
                          <img class="biaoqian" v-if="base.bmi > bmiVal[1]" src="@/assets/images/biaoqian.png" alt="">
                        </div>
                        <div class="line_item line_di">
                          <div class="body_val_text">{{ bmiVal[0] }}</div>
                        </div>
                        <div class="line_item line_zhong">
                          <div class="body_val_text">{{ bmiVal[1] }}</div>
                        </div>
                        <div class="line_item line_gao"></div>
                      </div>
                    </div>
                    <div class="body_item_group">與你同年齡、同性別的人，他們的BMI平均值為：<span>{{ bmi_g[2] }}</span></div>
                    <div class="body_item_group_db ">和他們相比，你的BMI：<span
                        :class="bmi_g[1] == '適中' ? 'group_zhong' : 'group_gao'">{{ bmi_g[1] }}</span></div>
                  </div>
                  <div class="body_item whr_wrap">
                    <div class="body_item_title">腰臀比WHR</div>
                    <div class="body_item_val">你的WHR：<span>{{ res.base && res.base.whr }}</span></div>
                    <div class="body_echat">
                      <div class="body_echat_title">與臨牀標準比</div>
                      <div class="line">
                        <div class="body_echat_val" :style="{ 'left': whrLeft > 62 ? 62 + '%' : whrLeft - 12 + '%' }">
                          {{ res.base && res.base.whr }} <span
                            :class="whr_n[1] == '正常' ? 'body_val_zhong' : 'body_val_gao'">{{ whr_n[1] }}</span></div>
                        <div class="biaoqian_box" :style="{ 'left': whrLeft - 3 + '%' }">
                          <img class="biaoqian" v-if="base.whr > whrVal[1]" src="@/assets/images/biaoqian.png" alt="">
                          <img class="biaoqian" v-if="base.whr <= whrVal[1]" src="@/assets/images/biaoqian3.png" alt="">
                          <!-- <img class="biaoqian" src="@/assets/images/biaoqian3.png" alt=""> -->
                        </div>
                        <div class="line_item line_zhong">
                          <div class="body_val_text">{{ whrVal[1] }}</div>
                        </div>
                        <div class="line_item line_gao"></div>
                      </div>
                    </div>
                    <div class="body_item_group">與你同年齡、同性別的人，他們的WHR平均值為：<span>{{ whr_g[2] }}</span></div>
                    <div class="body_item_group_db ">和他們相比，你的WHR：<span
                        :class="whr_g[1] == '適中' ? 'group_zhong' : 'group_gao'">{{ whr_g[1] }}</span></div>
                  </div>
                  <div class="body_item">
                    <div class="body_item_title">體脂率BFR</div>
                    <div class="body_item_val">你的BFR：<span>{{ res.base && res.base.fat }}%</span></div>
                    <div class="body_echat">
                      <div class="body_echat_title">與臨牀標準比</div>
                      <div class="line">
                        <div class="body_echat_val" :style="{ 'left': fatLeft > 52 ? 52 + '%' : fatLeft - 20 + '%' }">
                          {{ res.base && res.base.fat }}% <span
                            :class="fat_n[1] == '正常' ? 'body_val_zhong' : 'body_val_gao'">{{ fat_n[1] }}</span></div>
                        <div class="biaoqian_box" :style="{ 'left': fatLeft - 3 + '%' }">
                          <img class="biaoqian" v-if="base.fat < fatMinVal" src="@/assets/images/biaoqian2.png" alt="">
                          <img class="biaoqian" v-if="base.fat >= fatMinVal && base.fat <= fatMaxVal"
                            src="@/assets/images/biaoqian3.png" alt="">
                          <img class="biaoqian" v-if="base.fat > fatMaxVal" src="@/assets/images/biaoqian.png" alt="">
                        </div>
                        <div class="line_item line_di">
                          <div class="body_val_text">{{ fatVal[0] }}</div>
                        </div>
                        <div class="line_item line_zhong">
                          <div class="body_val_text">{{ fatVal[1] }}</div>
                        </div>
                        <div class="line_item line_gao"></div>
                      </div>
                    </div>
                    <div class="body_item_group">與你同年齡、同性別的人，他們的BFR平均值為：<span>{{ fat_g[2] }}</span></div>
                    <div class="body_item_group_db ">和他們相比，你的WHR：<span
                        :class="fat_g[1] == '適中' ? 'group_zhong' : 'group_gao'">{{ fat_g[1] }}</span></div>
                  </div>

                </div>
              </div>
            </van-swipe-item>
            <van-swipe-item v-if="modules.costs" @touchmove="checkMove($event)">
              <!-- 醫療費用預測 -->
              <div v-if="active == 'costs' || nextActive == 'costs'" class="costs qjc-bg-fff">
                <div class="costs_top">醫療費用預測</div>
                <div class="">
                  <div class="tip_p">
                    健康問題除會造成生命損失外，也會形成個人與家庭的經濟壓力。利用疾病現況評估與預測，可知個人在未來可能發生的慢性疾病、主要急重症或癌症，團隊可預估測未來數年醫療使用（如門診、住院、手術、用藥等）的頻率與相關費用趨勢；從趨勢圖中，可體會健康促進、健康管理與疾病管理的重要性，持續不斷健康促進，除可以改善生活(命)的品質，也能減輕或消除不必要的醫療費用負擔。
                  </div>
                  <div class="tip_p">從醫療費用的變化趨勢與相關的健康評估預測，或可供做個人保險、投資理財等生涯規劃之參考。</div>
                  <div class="tip_p">設算方式是以大陸主要城市（上海、深圳等地）及香港、台灣公開的統計數據，包含 GDP(國民生產總值)、NHE(國民醫療保健支出)、SHA(醫療衞生總開支帳目系統)
                    ，比較歷年數據的差異，定義各城市的相對權重，再依相關費用資料為基準，進行設算。</div>
                  <div class="tip_p">社會、經濟環境快速改變，個人消費水平差距懸殊，此醫療費用預測結果僅取代表最大部分人的醫療健康“基礎”支出數據，僅供參考。</div>
                </div>

                <ul>
                  <li class="qjc-clearfix">
                    <dl class="qjc-fl qjc-texta-l">
                      <dd class="qjc-fts-28">
                        <b>{{ res.m10.person_yearsfee.slice(-1)[0] }}</b>
                        元
                      </dd>
                      <dt>未來{{ res.m10.person_yearsfee.length }}年主要醫療費用</dt>
                    </dl>
                    <van-image width="3.43rem" height="1.35rem" class="qjc-fr"
                      :src="require('@/assets/images/costs_all_img.png')" />
                  </li>
                  <li class="qjc-clearfix" v-show="res.m10.person_allfee">
                    <dl class="qjc-fl qjc-texta-l">
                      <dd class="qjc-fts-28">
                        <b>{{ res.m10.person_allfee }}</b>
                        元
                      </dd>
                      <dt>終生累計醫療費用預估</dt>
                    </dl>
                    <van-image width="3.43rem" height="1.35rem" class="qjc-fr"
                      :src="require('@/assets/images/costs_p_img.png')" />
                  </li>
                </ul>
                <div class="costs-chart_title">未來{{ res.m10.person_yearsfee.length }}年主要醫療費用演化趨勢</div>
                <div class="costs-chart" key="costChart">

                </div>
                <p class="qjc-texta-l"><span class="qjc-c-dark qjc-ftw-b">注：</span>同族群（PLM，People Like
                  Me）:與你相似的人群--與你同性別同年齡段的人群。</p>
              </div>
            </van-swipe-item>
            <van-swipe-item v-if="modules.illness" @touchmove="checkMove($event)">
              <!-- 未來疾病風險預測 -->
              <div v-if="active == 'illness' || nextActive == 'illness'" class="illness qjc-texta-l qjc-bg-fff">
                <div>
                  <h3 class="qjc-c-dark">{{ res.base.categ == 'HEA1' ? '系統疾病風險' : (res.base.categ ==
                    'HEA2' ? '慢性病風險' : (res.base.categ == 'HEA3' ? '急重症風險' : '')) }}</h3>
                  <div class="tip_p_wrap" v-if="res.base.categ == 'HEA1'">
                    <div class="tip_p">生理系統失衡將導致發展為長期慢性病，不可逆的長期慢性病不但影響生活品質，也可使逐步併發成急重症、癌症的風險增加。</div>
                    <div class="tip_p">
                      從「生理系統疾病」演化情形可以預測個人未來數年罹患風險較高的慢性病，曲線的上升表示未來風險逐年提高。主要系統有：消化、呼吸、骨骼、肌肉、感覺器官、內分泌代謝和免疫系統。</div>
                    <div class="tip_p">
                      預測未來罹病風險高，若能適時適量的給予健康促進，並追蹤檢查評估，將能降低個人的患病風險，更能有助於未病先防。健康人群儘早做健康管理與促進的效益是最高的！因為各種健康風險尚在醖釀中，尚未發生器質性變化，這個階段的健康風險大多與生活、飲食與運動習慣息息相關，只要及早發現發現問題所在，大部分風險是可以逆轉的。
                    </div>
                  </div>
                  <div class="tip_p_wrap" v-if="res.base.categ == 'HEA2'">
                    <div class="tip_p">亞健康人群生活習慣欠佳，雖然目前看起來好好的，但長期發展下來，可能成為慢性病高危險群，甚至提高罹患急重症：如癌症、心梗與中風等的風險。</div>
                    <div class="tip_p">
                      從疾病現況評估可以進一步預測：個人未來數年可能罹患慢性病或急重症(稱為「欲病」)的風險與演化趨勢，估測出其未來罹病風險倍率，對高風險倍率之急重症，密切掌握其「欲病」與其未來該欲病的演變關聯。
                    </div>
                    <div class="tip_p">除預測未來罹病風險外高，若能適時適量的給予健康促進，改善核心指標，並追蹤檢查評估，將能降低個人的罹病風險，更能有助於斬斷「欲病」的發生。</div>
                  </div>
                  <div class="tip_p_wrap" v-if="res.base.categ == 'HEA3'">
                    <div class="tip_p">對醫療需求人群，即「既病者」而言，在病情急速下降或惡化，或將增加罹患急重症及失能的風險，甚至威脅生命。</div>
                    <div class="tip_p">
                      從疾病現況評估可以預測「既病者」個人未來數年可能罹患急重症的風險與演化趨勢，並與同族群PeopleLikeMe模式搭配，估測其罹病風險倍率，對高風險倍率之急重症，宜關切「既病」與該急重症的演變關聯。及早的疾病風險預警，可以幫助大眾及時發現問題、定位問題，結合專業醫療機構的幫助以及對自身狀況的瞭解，做到心中有數，有備無患，並及早做好疾病管理，及早防患、及早發現、及早治療。
                    </div>
                  </div>
                  <ul>
                    <li v-for="(item, index) in res.m07.dis_risk" :key="index">
                      <div class="illness-t">
                        <b class="name qjc-c-dark">{{ index + 1 }}.{{ item.devg }}</b>
                        <span @click="chartOn('risk', index, item, $event)" class="qjc-fr"
                          v-if="item.person_rates.length > 1">
                          查看詳細圖表
                          <van-icon name="arrow-down" />
                        </span>
                      </div>
                      <div class="chart qjc-hide" :key="item.devg">

                      </div>
                      <div class="prob qjc-texta-c qjc-clearfix">
                        <dl class="qjc-fl"
                          :class="res.base.categ == 'HEA1' || !item.compare_rates || item.compare_rates.length < 1 ? 'qjc-wid-100' : 'qjc-wid-50'">
                          <dd class="qjc-c-primary">
                            <b>{{ arrMax(item.person_rates) }}</b>%
                          </dd>
                          <dt>未來{{ item.person_rates.length == 3 ? '第3~第5' : item.person_rates.length }}年最高患病概率</dt>
                        </dl>
                        <dl v-if="res.base.categ != 'HEA1' && item.compare_rates && item.compare_rates.length > 0"
                          class="qjc-fl qjc-wid-50">
                          <dd class="qjc-c-primary">
                            <div v-if="item.person_rates[0] > 0 && item.compare_rates[0] > 0">
                              <b>{{ (item.person_rates[0] / item.compare_rates[0]).toFixed(2) }}</b>倍
                            </div>
                            <div v-else>
                              <b>不適用</b>
                            </div>
                          </dd>
                          <dt>是同族群平均概率的</dt>
                        </dl>
                      </div>
                      <div class="symptom">
                        <span class="qjc-c-dark qjc-ftw-b">主要症狀：</span>
                        {{ item.desc }}
                      </div>
                      <p class="qjc-texta-l"><span class="qjc-c-dark">注：</span>同族群（PLM，People Like
                        Me）:與你相似的人群--與你同性別同年齡段的人群。</p>
                    </li>
                  </ul>
                </div>
                <div v-if="res.base.categ == 'HEA3' && res.m07.cancer_risk && res.m07.cancer_risk.length > 0">
                  <h3 class="qjc-c-dark">癌症風險</h3>
                  <div class="tip_p_wrap">
                    <div class="tip_p">
                      根據臨牀數據研究，癌症常是一種或多種「生活習慣病」日積月累形成「癌症病根」，在個人免疫力或健康不佳時，病根就會適時浮現為「癌症確診」。因此癌症的防治，除須有良好的健康管理，增強體力與免疫力；慢性病患更需體會各既有慢性病對癌症可能觸發的影響，瞭解各項慢性病的發展，並確實做好慢性病的管理，以有效降低癌症發生的風險。
                    </div>
                    <div class="tip_p">罹患癌症不僅影響生活品質，甚至威脅生命。但癌症不可怕，依據科學的方法早期發現「癌症病根」，早期阻斷；或早期發現，早期治療，常可獲得控制，延長壽命。</div>
                  </div>
                  <ul>
                    <li v-for="(item, index) in res.m07.cancer_risk" :key="index">
                      <div class="illness-t">
                        <b class="name qjc-c-dark">{{ index + 1 }}.{{ item.devg }}</b>
                        <span @click="chartOn('cancer', index, item, $event)" class="qjc-fr">
                          查看詳細圖表
                          <van-icon name="arrow-down" />
                        </span>
                      </div>
                      <div class="chart qjc-hide" :key="item.devg">

                      </div>
                      <div class="prob qjc-texta-c qjc-clearfix">
                        <dl class="qjc-fl qjc-wid-100">
                          <dd class="qjc-c-primary">
                            <b>{{ arrMax(item.rates) }}</b>倍
                          </dd>
                          <dt>未來二十年最高患病倍率</dt>
                        </dl>
                      </div>
                      <div class="symptom">
                        <span class="qjc-c-dark qjc-ftw-b">主要症狀：</span>
                        {{ item.desc }}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </van-swipe-item>
            <van-swipe-item v-if="modules.noSick" @touchmove="checkMove($event)">
              <!-- 不患病&增壽 -->
              <div v-if="active == 'noSick' || nextActive == 'noSick'" class="noSick">
                <div>
                  <div class="">
                    <div class="tip_p">許多慢性病是生活習慣不良所引起，故又稱為生活習慣病或文明病。疾病會影響壽命長短，若能降低罹患風險，壽命就會相應延長。
                      決定長壽的因素很多，長壽不是一早註定的，而是通過自己的長期堅持與努力獲得的。只要控制好健康風險，任何人都可以比較健康長壽。</div>
                    <div class="tip_p">在此部分給出的，是基於相關疾病，針對你的性別、年齡、基本健康風險等基本情況，計算各年齡的患病概率，再找出其中患病概率最高的歲數。
                      例如：{{ res.m08.filter((a) => a.adagen_adj != -999)[0].devg }}，最高風險概率{{ res.m08.filter((a) =>
                        a.adagen_adj != -999)[0].rr_desc }}%，疾病影響最高年歲{{ res.m08.filter((a) => a.adagen_adj !=
                        -999)[0].maxage5 }}歲，不患病可增壽年數{{ res.m08.filter((a) => a.adagen_adj != -999)[0].adagen_adj
                      }}年——指的是對於該用户來説，其{{ res.m08.filter((a) => a.adagen_adj != -999)[0].devg }}的患病概率會在{{
                        res.m08.filter((a) => a.adagen_adj != -999)[0].maxage5 }}歲之前持續上升，在{{ res.m08.filter((a) =>
                        a.adagen_adj != -999)[0].maxage5 }}歲時達到最高的{{ res.m08.filter((a) => a.adagen_adj !=
                        -999)[0].rr_desc }}%，在{{ res.m08.filter((a) => a.adagen_adj != -999)[0].maxage5 }}歲之後則轉為下降；若終生不得{{
                        res.m08.filter((a) => a.adagen_adj != -999)[0].devg }}，則預期可增壽{{ res.m08.filter((a) => a.adagen_adj
                        != -999)[0].adagen_adj }}年。
                    </div>
                  </div>
                  <h3 class="qjc-texta-l qjc-fts-36 qjc-c-dark">原發性疾病</h3>
                  <ul>
                    <li v-for="(item, index) in res.m08.filter((a) => a.adagen_adj != -999)" :key="index">
                      <h4 class="qjc-texta-l qjc-fts-32 qjc-c-dark">{{ item.devg }}</h4>
                      <div class="qjc-clearfix">
                        <dl class="qjc-wid-50 qjc-fl">
                          <dd class="qjc-ftw-b qjc-c-dark">
                            <b class="qjc-fts-32">{{ item.rr_desc }}</b>%
                          </dd>
                          <dt>最高風險概率</dt>
                        </dl>
                        <dl class="qjc-wid-50 qjc-fl">
                          <dd class="qjc-ftw-b qjc-c-dark">
                            <b class="qjc-fts-32">{{ item.maxage5 }}</b>歲
                          </dd>
                          <dt>疾病影響最高年歲</dt>
                        </dl>
                      </div>
                      <p>不患病可增壽年數：<span class="qjc-c-primary"><b class="qjc-fts-32">{{ item.adagen_adj }}</b>年</span>
                      </p>
                    </li>
                  </ul>
                </div>
                <div>
                  <h3 class="qjc-texta-l qjc-fts-36 qjc-c-dark">併發性疾病</h3>
                  <ul>
                    <li v-for="(item, index) in res.m08.filter((a) => a.adagen_adj == -999)" :key="index">
                      <h4 class="qjc-texta-l qjc-fts-32 qjc-c-dark">{{ item.devg }}</h4>
                      <div class="qjc-clearfix">
                        <dl class="qjc-wid-50 qjc-fl">
                          <dd class="qjc-ftw-b qjc-c-dark">
                            <b class="qjc-fts-32">{{ item.rr_desc }}</b>%
                          </dd>
                          <dt>最高風險概率</dt>
                        </dl>
                        <dl class="qjc-wid-50 qjc-fl">
                          <dd class="qjc-ftw-b qjc-c-dark">
                            <b class="qjc-fts-32">{{ item.maxage5 }}</b>歲
                          </dd>
                          <dt>疾病影響最高年歲</dt>
                        </dl>
                      </div>
                      <!-- <p>不患病可增壽年數：<span class="qjc-c-primary">--</span></p> -->
                    </li>
                  </ul>
                </div>
              </div>
            </van-swipe-item>
            <van-swipe-item v-if="modules.improve" @touchmove="checkMove($event)">
              <!-- 健康管理和改善方案 -->
              <div v-if="active == 'improve' || nextActive == 'improve'" class="improve qjc-texta-l qjc-bg-fff">
                <div v-if="res.m12 && res.m14" class="improve-body">
                  <div class="target">
                    <h3 class="qjc-fts-36 qjc-c-dark">體型改善目標</h3>
                    <h4 class="qjc-c-dark qjc-fts-32">建議改善方案</h4>
                    <div class="program-res">
                      <dl>
                        <dt>計劃時長</dt>
                        <dd class="qjc-texta-l">
                          <b class="qjc-fts-32 qjc-c-dark">{{ res.m12.weeks.slice(-1)[0] }}</b>
                          周
                        </dd>
                      </dl>
                      <dl>
                        <dt>平均每日飲食熱量</dt>
                        <dd class="qjc-texta-c">
                          <b class="qjc-fts-32 qjc-c-dark">{{ res.m14.bmr }}</b>
                          大卡
                        </dd>
                      </dl>
                      <dl>
                        <dt>建議熱量改善目標</dt>
                        <dd class="qjc-texta-c">
                          <b class="qjc-fts-32 qjc-c-dark">{{ res.m14.bmr_df }}大卡/日</b>
                        </dd>
                      </dl>
                      <dl>
                        <dt>建議運動次數</dt>
                        <dd class="qjc-texta-r">
                          <b class="qjc-fts-32 qjc-c-dark">{{ res.m14.s1 + res.m14.s2 + res.m14.s3 }}</b>
                          次/周
                        </dd>
                      </dl>
                    </div>
                    <div class="weight_chart_title">體重改善目標</div>
                    <div class="weight_chart"></div>
                    <div class="weight_chart_title">腰臀比改善目標</div>
                    <div class="whr_chart"></div>

                  </div>
                  <div class="program">

                    <div class="new_bmi">
                      <!--BMI 體型 -->
                      <div class="new_bmi_cell">你的BMI是 <span class="new_bmi_val">{{ res.m14.bmi }}</span>，屬於 <span
                          class="new_bmi_b">{{ res.m14.bmi_stat }}</span>型；</div>
                      <!-- 理想體重 -->
                      <div class="new_bmi_cell">你的理想體重為 <span class="new_bmi_lx bmi_lx1">{{ res.m14.st_wd }}</span> ~
                        <span class="new_bmi_lx bmi_lx2">{{ res.m14.st_wu }}</span>公斤；
                      </div>
                      <!--運動和飲食改善 -->
                      <div class="new_bmi_p">
                        體重為影響健康的最重要指標之一，過胖或過瘦有可能對健康造成危害，導致疾病的發生，應注意體重的維持及改善，通過運動及飲食來維持及改善體重最為理想，依據你的BMI與理想體重，建議你應<span
                          class="new_bmi_p_v">{{ res.m14.food_supp }}</span>，及<span class="new_bmi_p_v2">{{
                            res.m14.sport_supp }}</span>;</div>

                    </div>

                    <div class="eat">
                      <h5 class="qjc-fts-28 qjc-c-dark">飲食部分建議</h5>
                      <p>説明：1、一份約一個成人拳頭或手掌大。2、一杯約500cc</p>
                      <ul>
                        <li>
                          <div class="" v-if="res.m14.vege == 1">
                            <p>飲食部分建議先<span class="improve_c0">{{ res.m14.c0 }}</span>肉類<b>{{ res.m14.c1 == 0 ? '不變' :
                              res.m14.c1 + '卡' }}</b>，
                              再<span class="improve_c0">{{ res.m14.c0 }}</span>主食<b class="staple_ka">{{ res.m14.c2 == 0
                                ?
                                '不變' : res.m14.c2 + '卡' }}</b>,
                              豆類<b class="beans_ka">{{ res.m14.c3 == 0 ? '維持' : res.m14.c3 + '卡' }}</b>，
                              水果<b class="fruits_ka">{{ res.m14.c4 == 0 ? '維持' : res.m14.c4 + '卡' }}</b>，
                              乳製品<b class="cream_ka">{{ res.m14.c5 == 0 ? '維持' : res.m14.c5 + '卡' }}</b>。
                            </p>
                          </div>
                          <div class="" v-if="res.m14.vege == 2">
                            <p>飲食部分建議先<span class="improve_c0">{{ res.m14.c0 }}</span>主食<b>{{ res.m14.c2 == 0 ? '不變' :
                              res.m14.c2 + '卡' }}</b>，
                              再<span class="improve_c0">{{ res.m14.c0 }}</span>豆類<b class="staple_ka">{{ res.m14.c3 == 0
                                ?
                                '維持' : res.m14.c3 + '卡' }}</b>,
                              水果<b class="beans_ka">{{ res.m14.c4 == 0 ? '維持' : res.m14.c4 + '卡' }}</b>，
                              乳製品<b class="fruits_ka">{{ res.m14.c5 == 0 ? '維持' : res.m14.c5 + '卡' }}</b>。
                            </p>
                          </div>
                        </li>
                        <li>
                          <div class="m14_t">
                            <van-image width="0.3rem" height="0.28rem"
                              :src="require('@/assets/images/zhushilei.png')" />
                            主食類(擇一)
                          </div>
                          <div class="m14_v">
                            <p>以米飯為主食者，每天請<span class="improve_c0" v-if="res.m14.c21 != 0">{{ res.m14.c0 }}</span><b>{{
                              res.m14.c21 == 0 ? '維持' : res.m14.c21
                                + '碗' }}</b></p>
                            <p>以麪條為主食者，每天請<span class="improve_c0" v-if="res.m14.c22 != 0">{{ res.m14.c0 }}</span><b>{{
                              res.m14.c22 == 0 ? '維持' : res.m14.c22
                                + '碗' }}</b></p>
                            <p>以雜糧為主食者，每天請<span class="improve_c0" v-if="res.m14.c23 != 0">{{ res.m14.c0 }}</span><b>{{
                              res.m14.c23 == 0 ? '維持' : res.m14.c23
                                + '碗' }}</b></p>
                            <p>以麪包為主食者，每天請<span class="improve_c0" v-if="res.m14.c24 != 0">{{ res.m14.c0 }}</span><b>{{
                              res.m14.c24 == 0 ? '維持' : res.m14.c24
                                + '克' }}</b></p>
                          </div>
                        </li>
                        <li v-if="res.m14.vege == 1">
                          <div class="m14_t">
                            <van-image width="0.31rem" height="0.28rem" :src="require('@/assets/images/roulei.png')" />
                            肉類<br>(擇一)
                          </div>
                          <div class="m14_v">
                            <p>以牛肉、豬肉、羊肉家畜等，每天請<span class="improve_c0" v-if="res.m14.c11 != 0">{{ res.m14.c0
                                }}</span><b>{{ res.m14.c11 == 0 ? '維持' : res.m14.c11
                                  + '份' }}</b></p>
                            <p>以魚、蝦、蟹，海鮮等，每天請<span class="improve_c0" v-if="res.m14.c12 != 0">{{ res.m14.c0
                                }}</span><b>{{ res.m14.c12 == 0 ? '維持' : res.m14.c12
                                  + '份' }}</b></p>
                            <p>以雞肉、鴨肉，家禽等，每天請<span class="improve_c0" v-if="res.m14.c12 != 0">{{ res.m14.c0
                                }}</span><b>{{ res.m14.c12 == 0 ? '維持' : res.m14.c12
                                  + '份' }}</b></p>
                          </div>
                        </li>
                        <li>
                          <div class="m14_t">
                            <van-image width="0.31rem" height="0.28rem" :src="require('@/assets/images/shucai.png')" />
                            蔬菜類
                          </div>
                          <div class="m14_v">指的是葉菜（如菠菜、高麗菜）、花菜（如花椰菜、金針花）、海菜（如紫菜、海帶）、菇類（如香菇、洋菇）等，每日宜多變化並以當季新鮮為主。每天請<span
                              class="improve_c0">增加</span><b>{{ res.m14.c99 }}份</b></div>
                          <!-- <b class="qjc-c-dark m14_l">
														<span>{{ res.m14.c0=='維持'?'+0.5':'+'+accMul(res.m14.c21,1.5) }}</span>份
													</b> -->
                        </li>
                        <li>
                          <div class="m14_t">
                            <van-image width="0.2rem" height="0.3rem" :src="require('@/assets/images/doulei.png')" />
                            豆類
                          </div>
                          <div class="m14_v">指的是提供豐富植物性蛋白質的黃豆、毛豆、黑豆、其他豆類及其製品，如豆腐、無糖豆漿、小方豆乾等。每天請<span class="improve_c0"
                              v-if="res.m14.c31 != 0">{{ res.m14.c0 }}</span><b>{{ res.m14.c31 == 0 ? '維持' : res.m14.c31
                                +
                                '份' }}</b></div>

                        </li>
                        <li>
                          <div class="m14_t">
                            <van-image width="0.24rem" height="0.3rem"
                              :src="require('@/assets/images/shuiguolei.png')" />
                            水果類
                          </div>
                          <div class="m14_v">不含蔬菜。每天請<span class="improve_c0" v-if="res.m14.c41 != 0">{{ res.m14.c0
                              }}</span><b>{{ res.m14.c41 == 0 ? '維持' : res.m14.c41 +
                                '份' }}</b></div>
                        </li>
                        <li>
                          <div class="m14_t">
                            <van-image width="0.27rem" height="0.3rem" :src="require('@/assets/images/ruzhilei.png')" />
                            乳脂類
                          </div>
                          <div class="m14_v">指的是鮮乳、保久乳、優酪乳及乳酪等乳製品。每天請<span class="improve_c0" v-if="res.m14.c51 != 0">{{
                            res.m14.c0 }}</span><b>{{ res.m14.c51 == 0 ? '維持' : res.m14.c51 +
                                '份' }}</b></div>
                        </li>
                      </ul>
                    </div>
                    <div class="sport" v-if="res.m14.s1">
                      <h4 class="qjc-fts-28 qjc-c-dark">運動部分建議</h4>
                      <p>運動項目依強度，分為低強度、中強度與高強度，各強度運動項目可參考下列所 述，建議根據個人作息時間與身心負擔，進行適當的彈性調整。</p>
                      <table class="qjc-wid-100" border="0" cellpadding="0" cellspacing="0">
                        <tr>
                          <th></th>
                          <th>低強度運動</th>
                          <th>中強度運動</th>
                          <th>高強度運動</th>
                        </tr>
                        <tr>
                          <td>增加次數</td>
                          <td><span>{{ res.m14.s1 }}</span>次/周</td>
                          <td><span>{{ res.m14.s2 }}</span>次/周</td>
                          <td><span>{{ res.m14.s3 }}</span>次/周</td>
                        </tr>
                        <tr>
                          <td>時長</td>
                          <td><span>30</span>分鐘</td>
                          <td><span>30</span>分鐘</td>
                          <td><span>30</span>分鐘</td>
                        </tr>
                      </table>
                      <div class="symptom">
                        <p>低強度運動：如散步、做家事、逛街、遛狗等；</p>
                        <p>中強度運動：如快步走、有氧運動、打太極拳、騎腳踏車、打高爾夫球、爬樓梯、跳舞、打桌球、騎馬等；</p>
                        <p>高強度運動：如游泳、打網球、打籃球、跑步、仰卧起坐、滑雪、跳繩等。</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="improve-biom" v-if="res.m13">
                  <h3 class="qjc-texta-l qjc-fts-36 qjc-c-dark">生化指標改善方案</h3>
                  <div class="tip_p">
                    由於生化指標常是身體或疾病的內在表徵，故對於改善生化指標應以整體而言之，即通過飲食運動改善或治療疾病獲得改善。整體健康風險得到改善，個人許多關鍵指標也會隨之得到改善，當然這種改善是一定範圍內的，畢竟大部分疾病是不“可逆”的，許多風險從量變到達質變後，便很難逆轉並恢復原狀，但可以通過合理手段持續控制。因此，儘可能早的、經常性的身體檢查結合大數據評估，便是最佳的發現與應對手段。
                  </div>
                  <div class="tip_p">“早發現、早介入、早阻斷”，用科學的辦法將風險控制在一定水平，並結合客製化可穿戴或居家設備實時監測健康風險，可在目前科技手段下將疾病風險或重症發作的風險降至最低。
                  </div>
                  <div class="tip_p">關於單一項生化指標的改善內容，建議可參考健檢或專業醫療機構的建議資訊，並於3-6個月週期內持續追蹤；另外，也可請專業醫師確認原因，遵循其診斷和意見。</div>
                  <div class="tip_p">生化指標會經常發生改變，代表着健康狀況和健康風險發生了變化。定期使用大數據進行分析，及時發現問題，預防疾病，掌握健康。</div>
                  <div class="tip_p">懷孕會造成血壓略微升高，這是正常的現象。另外，孕產期女性需要更加嚴格的監控血糖變化，請多加註意。</div>
                  <div class="tip_p">根據你的健康狀況，我們建議你在短期內對生化指標進行適當改善，改善目標如下：</div>
                  <div class="improve-table">
                    <table class="qjc-wid-100" border="0" cellpadding="0" cellspacing="0">
                      <thead>
                        <td></td>
                        <td>主要檢查項目</td>
                        <td>檢查結果</td>
                        <td>健康風險</td>
                        <td>短期改善目標</td>
                      </thead>
                      <tr v-for="(item, index) in improveBiomData.CBC" :key="item.id">
                        <td v-if="index == 0" :rowspan="improveBiomData.CBC.length" class="left-side">血液常規</td>
                        <td :class="{ 'qjc-ftw-b qjc-c-dark': item.score > 2 }">{{ item.item_d }}</td>
                        <td><b>{{ item.value }}</b> {{ item.unit }}</td>
                        <td>
                          <i v-for="i in item.score" :key="i"
                            :class="{ 'iconxiaolian': item.score == 1, 'iconbukubuxiaolian': item.score == 2, 'iconkulian c-danger': item.score > 2 }"
                            class="iconfont"></i>
                        </td>
                        <td>{{ item.score <= 2 ? item.target : item.target + " " + item.unit }}</td>
                      </tr>
                      <tr v-for=" (item, index) in improveBiomData.bloodGlucose" :key="item.id">
                        <td v-if="index == 0" :rowspan="improveBiomData.bloodGlucose.length" class="left-side">血糖</td>
                        <td :class="{ 'qjc-ftw-b qjc-c-dark': item.score > 2 }">{{ item.item_d }}</td>
                        <td><b>{{ item.value }}</b> {{ item.unit }}</td>
                        <td>
                          <i v-for="i in item.score" :key="i"
                            :class="{ 'iconxiaolian': item.score == 1, 'iconbukubuxiaolian': item.score == 2, 'iconkulian c-danger': item.score > 2 }"
                            class="iconfont"></i>
                        </td>
                        <td>{{ item.score <= 2 ? item.target : item.target + " " + item.unit }}</td>
                      </tr>
                      <tr v-for="(item, index) in improveBiomData.bloodLipids" :key="item.id">
                        <td v-if="index == 0" :rowspan="improveBiomData.bloodLipids.length" class="left-side">血脂肪</td>
                        <td :class="{ 'qjc-ftw-b qjc-c-dark': item.score > 2 }">{{ item.item_d }}</td>
                        <td><b>{{ item.value }}</b> {{ item.unit }}</td>
                        <td>
                          <i v-for="i in item.score" :key="i"
                            :class="{ 'iconxiaolian': item.score == 1, 'iconbukubuxiaolian': item.score == 2, 'iconkulian c-danger': item.score > 2 }"
                            class="iconfont"></i>
                        </td>
                        <td>{{ item.score <= 2 ? item.target : item.target + " " + item.unit }}</td>
                      </tr>
                      <tr v-for="(item, index) in improveBiomData.ALT" :key="item.id">
                        <td v-if="index == 0" :rowspan="improveBiomData.ALT.length" class="left-side">肝膽功能</td>
                        <td :class="{ 'qjc-ftw-b qjc-c-dark': item.score > 2 }">{{ item.item_d }}</td>
                        <td><b>{{ item.value }}</b> {{ item.unit }}</td>
                        <td>
                          <i v-for="i in item.score" :key="i"
                            :class="{ 'iconxiaolian': item.score == 1, 'iconbukubuxiaolian': item.score == 2, 'iconkulian c-danger': item.score > 2 }"
                            class="iconfont"></i>
                        </td>
                        <td>{{ item.score <= 2 ? item.target : item.target + " " + item.unit }}</td>
                      </tr>
                      <tr v-for="(item, index) in improveBiomData.renalFunc" :key="item.id">
                        <td v-if="index == 0" :rowspan="improveBiomData.renalFunc.length" class="left-side">腎功能</td>
                        <td :class="{ 'qjc-ftw-b qjc-c-dark': item.score > 2 }">{{ item.item_d }}</td>
                        <td><b>{{ item.value }}</b> {{ item.unit }}</td>
                        <td>
                          <i v-for="i in item.score" :key="i"
                            :class="{ 'iconxiaolian': item.score == 1, 'iconbukubuxiaolian': item.score == 2, 'iconkulian c-danger': item.score > 2 }"
                            class="iconfont"></i>
                        </td>
                        <td>{{ item.score <= 2 ? item.target : item.target + " " + item.unit }}</td>
                      </tr>
                    </table>
                  </div>
                  <div class="symptom">
                    <i class="iconfont iconxiaolian"> ：良好</i>
                    <i class="iconfont iconbukubuxiaolian"> ：一般</i>
                    <i class="iconfont iconkulian c-danger"> ：需要改善</i>
                  </div>
                </div>
              </div>
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { NavBar, Grid, GridItem, Image, Icon, Sticky, Toast, Swipe, SwipeItem, Circle } from 'vant'
Vue.use(NavBar)
  .use(Grid)
  .use(GridItem)
  .use(Image)
  .use(Icon)
  .use(Sticky)
  .use(Toast)
  .use(Swipe)
  .use(SwipeItem)
  .use(Circle);

import { getReportDetail } from '@/js/axios.js'
import { accMul } from '@/js/utils.js'
import { Base64 } from 'js-base64'


var echarts = require('echarts');

export default {
  name: 'result',
  data () {
    return {
      id: '',//報告id
      c: null,//報告修改次數 只能修改一次
      active: 'branch',//當前展示模塊(與class名對應) 默認第一個生化指標
      nextActive: '',//另一個展示模塊(左右切換的另一個模塊,避免出現空白)
      offsetTop: 0,//模塊列表吸頂距離 默認為0
      scoreTip: false, //健康分 tip
      scoreTip1: false,
      scoreVal: 0,
      infoLeft: '4%',
      sangaoVal: '1',
      dlVal: '1',
      medicalVal: '1',
      injuryVal: '1',
      res: {
        base: {
          package: '',
          health_type: '',//所屬人群
          height: '',//身高
          weight: '',//體重
          fat: '',//體脂率
          bust: '',//胸圍
          waist: '',//腰圍
          hip: '',//臀圍
          sex: ''//男女 1男 2女
        },
        m01: {//總體健康評估和生命預測
          pre_lift: '',//預期壽命
          lift_100: '',//百歲概率
          pre_rem: '',//年齡區間
          rates_ages: [],//年齡
          heal_rates: [],//健康率
          lift_rates: [],//存活概率
          lost_heal_ratio: []//失能率
        },
        m05: {//體型評估
          body_g: [],//體型評估總結果
          bmi_g: [],//bmi
          whr_g: [],//whr
          fat_g: []//bfr
        },
        m06: {},//生化指標評估表格數據
        m07: {//未來疾病風險預測
          dis_risk: [],//疾病列表
          cancer_risk: []//癌症列表(醫療需求者可能會有)
        },
        m08: [],//不患病&增壽
        m10: {//醫療費用預測
          person_allfee: '',//終生醫療費用預估
          person_yearsfee: [],//未來十年醫療費用預估
          compare_yearsfee: []//未來十年同族群醫療費用預估
        },
        m12: {//健康管理和改善方案
          sugweight: [],//當前體重取[0] 目標體重取最後一個
          sugwhr: [],//當前腰臀比去[0] 目標腰臀比去最後一個
          weeks: []//計劃時長
        },
        m14: {//健康管理和改善方案
          bmr: '',//平均每日飲食熱量
          c0: '',//判斷當前維持狀態
          c21: '',//主食類
          c12: '',//肉類
          c31: '',//豆類
          c41: '',//水果類
          c51: ''//乳脂類
        },
        m15: []//生化指標評估：常見疾病風險倍率
      },//數據結構 和後台傳輸數據保持一致
      biomData: {
        CBC: [],//血液常規
        bloodGlucose: [],//血糖
        bloodLipids: [],//血脂肪
        ALT: [],//肝膽功能
        renalFunc: []//腎功能
      },//生化指標評估數據
      improveBiomData: {
        CBC: [],//血液常規
        bloodGlucose: [],//血糖
        bloodLipids: [],//血脂肪
        ALT: [],//肝膽功能
        renalFunc: []//腎功能
      },//改善生化指標評估數據
      BMIGroup: false,//小提示
      WHRGroup: false,//小提示
      BFRGroup: false,//小提示
      start: 0,//左右切換touch初始x位置
      startY: 0,//左右切換touch初始Y位置

      currentRate: 0,// 進度條當前進度
      rate: 0,// 進度條目標進度
      rateTitle: '低',
      rateText: '健康',
      bmi_n: [],
      fat_n: [],
      whr_n: [],
      bmi_g: [],
      fat_g: [],
      whr_g: [],
      body_g: [],
      fatVal: [],
      whrVal: [],
      bmiVal: [],
      base: {},
      fatLeft: 0,
      whrLeft: 0,
      bmiLeft: 0,
      fatMinVal: 0,
      fatMaxVal: 0,
      bomiBtn: 1,
      hasGroup: false,
    }
  },
  computed: {
    modules () {//當前結果頁所擁有模塊
      var list = {
        branch: true, //健康分
        biom: this.res.m06,//生化指標評估
        core: this.res.m15,//生化指標評估
        health: (this.res.base.categ == "HEA1" && this.res.base.age && this.res.m02) || (this.res.base.categ == "HEA2" && this.res.m15),//未來健康風險預測(尊享非醫療需求者會有)
        total: true,//總體健康評估和生命預測
        bodily: true,//體型評估
        costs: true,//醫療費用預測
        illness: true,//未來疾病風險預測
        noSick: this.res.base.categ != "HEA3" && this.res.m08,//不患病&增壽
        improve: this.res.m13//健康管理和改善方案
      };
      return list;
    },

    // 進度條顏色
    rateColor () {
      let color = {};

      if (this.res.base.categ == "HEA1") {// 健康
        color = {
          '0%': '#b3e548',
          '100%': '#b3e548',
        }
        this.rateTitle = '低'
        this.rateText = '健康'
        this.rate = 33
      } else if (this.res.base.categ == "HEA2") {// 亞健康
        color = {
          '0%': '#b3e548',
          '100%': '#E5CB72',
        }
        this.rateTitle = '中'
        this.rateText = '亞健康'
        this.rate = 66
      } else if (this.res.base.categ == "HEA3") {// 醫療需求
        color = {
          '0%': '#b3e548',
          '100%': '#E77C7C',
        }
        this.rateTitle = '高'
        this.rateText = '醫療需求'
        this.rate = 100
      }
      return color;
    },
  },
  watch: {
    $route () {
      this.id = this.$route.params.id;
    },// 路由變化更新id
    id () {
      // this.setDefaultData()
      // return
      getReportDetail({ id: this.id }).then(res => {
        if (res.code == 200) {
          var result = JSON.parse(Base64.decode(res.data));

          this.res = result;

          this.rate = parseFloat(this.res.base.mlev ? this.res.base.mlev : 0);
          this.scoreVal = parseFloat(this.res.base.mlev ? this.res.base.mlev : 0);

          this.base = result.base;
          this.bmi_n = result.m05.bmi_n;
          this.fat_n = result.m05.fat_n;
          this.whr_n = result.m05.whr_n;
          this.bmi_g = result.m05.bmi_g;
          this.fat_g = result.m05.fat_g;
          this.whr_g = result.m05.whr_g;
          this.body_g = result.m05.body_g;
          this.fatVal = result.m05.fat_n[2].split('~');
          this.bmiVal = result.m05.bmi_n[2].split('~');
          this.whrVal = result.m05.whr_n[2].split('<');
          this.fatMinVal = this.fatVal[0].split('%')[0];
          this.fatMaxVal = this.fatVal[1].split('%')[0];


          this.handleBmiLeft(result.base.bmi);
          this.handleFatLeft(result.base.fat);
          this.handleWhrLeft(result.base.whr);

          //顯示當前模塊圖表
          this.showChart();
        } else {
          Toast.fail(data.msg);
          this.$router.replace('/user');
        }
      })
    }// id變化,重新獲取數據
  },
  mounted () {
    // 初次進入回到頂部
    window.scrollTo(0, 0);

    document.title = '評估結果';
    this.id = this.$route.params.id;// 當前結果id

    // 模塊列表吸頂距離
    this.$nextTick(() => {

      //切換模塊完成後合併為一個,否則頁面高度和切換可能會出現問題
      document.querySelector('.van-swipe__track').addEventListener('transitionend', () => {
        this.nextActive = this.active;
      });
    });

  },
  methods: {
    setDefaultData () {
      const defaultData = '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'

      var result = JSON.parse(window.atob(defaultData));

      this.res = result;

      this.rate = parseFloat(this.res.base.mlev ? this.res.base.mlev : 0);
      this.scoreVal = parseFloat(this.res.base.mlev ? this.res.base.mlev : 0);

      this.base = result.base;
      this.bmi_n = result.m05.bmi_n;
      this.fat_n = result.m05.fat_n;
      this.whr_n = result.m05.whr_n;
      this.bmi_g = result.m05.bmi_g;
      this.fat_g = result.m05.fat_g;
      this.whr_g = result.m05.whr_g;
      this.body_g = result.m05.body_g;
      this.fatVal = result.m05.fat_n[2].split('~');
      this.bmiVal = result.m05.bmi_n[2].split('~');
      this.whrVal = result.m05.whr_n[2].split('<');
      this.fatMinVal = this.fatVal[0].split('%')[0];
      this.fatMaxVal = this.fatVal[1].split('%')[0];


      this.handleBmiLeft(result.base.bmi);
      this.handleFatLeft(result.base.fat);
      this.handleWhrLeft(result.base.whr);

      //顯示當前模塊圖表
      this.showChart();

    },
    handleBmiLeft (val) {
      let lineV = this.bmiVal[1] - this.bmiVal[0];
      let rang = lineV * 3;
      let minV = this.bmiVal[0] - lineV;
      let maxV = Number(this.bmiVal[1]) + Number(lineV);
      let left = 0
      if (val <= minV) {
        left = 0
      } else if ((val > minV) && (val < this.bmiVal[0])) {
        left = ((val - minV) / rang) * 100
      } else if ((val > this.bmiVal[0]) && (val < this.bmiVal[1])) {
        left = ((val - minV) / rang) * 100
      } else if ((val > this.bmiVal[1]) && (val < maxV)) {
        left = (((val - minV) / rang) * 100 > 96 ? 96 : ((val - minV) / rang) * 100)
      } else {
        left = 96
      }

      this.bmiLeft = left;
    },
    handleFatLeft (val) {
      let fatVal = this.fatVal ? this.fatVal : [];
      // 284
      let lineV = fatVal[1].split('%')[0] - fatVal[0].split('%')[0];
      let rang = lineV * 3;
      let minV = fatVal[0].split('%')[0] - lineV;
      let maxV = Number(fatVal[1].split('%')[0]) + Number(lineV);
      let left = 0;
      if (val <= minV) {
        left = 0
      } else if (val > minV && val < fatVal[0].split('%')[0]) {
        left = ((val - minV) / rang) * 100
      } else if (val > fatVal[1].split('%')[0] && val < maxV) {
        left = (((val - minV) / rang) * 100 > 96 ? 96 : ((val - minV) / rang) * 100)
      } else if (val > fatVal[0].split('%')[0] && val < fatVal[1].split('%')[0]) {
        left = (((val - minV) / rang) * 100 > 96 ? 96 : ((val - minV) / rang) * 100)
      } else {
        left = 96
      }

      this.fatLeft = left
    },
    handleWhrLeft (val) {
      let lineV = this.whrVal[1];
      let rang = lineV * 2;
      let left = 0
      if (val <= 0) {
        left = 0
      } else if (val >= rang) {
        left = 96
      } else {
        left = ((val / rang) * 100) > 96 ? 96 : ((val / rang) * 100)
      }
      this.whrLeft = left
    },
    lookMore () {
      if (this.res.babyinf) {// 母嬰
        this.$router.push({
          path: '/editMyQuestion/' + this.id,
          query: {
            isedit: this.res.base.isedit ? this.res.base.isedit : 0
          }
        });
      } else {// 健康100、自由定製
        this.$router.push({
          path: '/editQuestion/' + this.id,
          query: {
            isedit: this.res.c
          }
        });
      }
    },

    checkModule (module) {
      this.active = module;
      window.scrollTo(0, (document.querySelector('.list').offsetTop - document.querySelector('.list-title').offsetHeight));

      setTimeout(() => {
        this.showChart();

        this.$refs.swp.swipeTo(this.getModules().indexOf(module));

      }, 100);
    },//切換模塊列表

    clickCheckModule (module) {
      //this.nextActive = this.active;
      // Toast.fail(module)

      this.checkModule(module)
    },//點擊模塊名切換模塊

    slide (index) {
      this.checkModule(this.getModules()[index]);
    },//滑動切換模塊

    touchStart (e) {
      return
      this.nextActive = this.active;
      this.start = e.changedTouches[0].pageX;
      this.startY = e.changedTouches[0].pageX;

    },

    checkMove (e) {
      let move = e.changedTouches[0].pageX,
        arr = this.getModules(),
        nowIndex = arr.indexOf(this.nextActive),
        nexIndex;

      //是否是上下滑動(防止上下滑動觸發左右滑動事件) 上下滑動超過10單位定位上下滑動
      let upDown = Math.abs(e.changedTouches[0].screenY - this.startY) > 10 ? true : false;
      if (!upDown) {
        if (this.start > move && nowIndex < arr.length - 1) {
          nexIndex = nowIndex + 1;
        } else if (this.start < move && nowIndex > 0) {
          nexIndex = nowIndex - 1;
        } else {
          nexIndex = nowIndex;
        }

        this.active = arr[nexIndex];
      }
    },//判斷左滑動還是右滑動,便於顯示下一模塊,使切換更平滑

    getModules () {
      let arr = [];
      for (let i in this.modules) {
        this.modules[i] ? arr.push(i) : '';
      }
      return arr;
    },//獲取當前所有模塊名稱數組

    chartOn (type, index, item, e) {
      var chartDom;
      if (e.target.className.indexOf('van-icon') != -1) {
        chartDom = e.target.parentNode.parentNode.nextElementSibling;
      } else {
        chartDom = e.target.parentNode.nextElementSibling;
      }
      if (chartDom.className.indexOf(type) == -1) {
        chartDom.className += ' ' + type + index;
      }
      if (chartDom.className.indexOf('qjc-hide') == -1) {
        chartDom.className += ' qjc-hide';
      } else {
        chartDom.className = chartDom.className.replace('qjc-hide', '');
      }
      if (type == 'risk') {//疾病
        this.illnessChart('.' + type + index, item.person_rates, item.compare_rates);
      } else if (type == 'cancer') { //癌症
        this.cancerChart('.' + type + index, item.devg, item.rates);
      }
    },//未來疾病展示圖表 參數1：當前所屬圖表(疾病或癌症)

    arrMax (arr) {
      var max = Number(arr[0]);//默認取第一個
      for (var i = 1; i < arr.length; i++) {//從第二個開始篩選
        Number(arr[i]) >= max ? (max = arr[i]) : '';
      }
      return max;
    },//數組中最大值

    accMul,

    //生化指標表格數據篩選分類 參數：當前所在模塊
    biomClassify (module) {
      var CBC = ['WBC', 'HGB', 'PLT'],//血液常規
        bloodGlucose = ['FG', 'HBA1C'],//血糖
        bloodLipids = ['CHOL', 'LDLC', 'HDLC', 'TG'],//血脂肪
        ALT = ['GOT', 'GPT', 'ALP', 'ALB'],//肝膽功能
        renalFunc = ['CRE', 'UA', 'EGFR'];//腎功能

      var nowData, data;
      if (module == 'biom') {//生化指標評估模塊
        nowData = this.biomData = {
          CBC: [],//血液常規
          bloodGlucose: [],//血糖
          bloodLipids: [],//血脂肪
          ALT: [],//肝膽功能
          renalFunc: []//腎功能
        };
        data = this.res.m06;
        let hasGroup = false;
        hasGroup = data[0].group_p ? true : false
        this.hasGroup = hasGroup
      } else {//生化指標改善模塊 
        nowData = this.improveBiomData = {
          CBC: [],//血液常規
          bloodGlucose: [],//血糖
          bloodLipids: [],//血脂肪
          ALT: [],//肝膽功能
          renalFunc: []//腎功能
        };
        data = this.res.m13;
      }

      for (var i = 0; i < data.length; i++) {
        if (CBC.indexOf(data[i].item) != -1) {
          nowData.CBC.push(data[i]);
        } else if (bloodGlucose.indexOf(data[i].item) != -1) {
          nowData.bloodGlucose.push(data[i]);
        } else if (bloodLipids.indexOf(data[i].item) != -1) {
          nowData.bloodLipids.push(data[i]);
        } else if (ALT.indexOf(data[i].item) != -1) {
          nowData.ALT.push(data[i]);
        } else if (renalFunc.indexOf(data[i].item) != -1) {
          nowData.renalFunc.push(data[i]);
        }
      }
    },

    //未來健康風險預測-亞健康(四高)數據篩選分類
    threeHighsClassify () {
      var three = ['A01', 'A02', 'A16', 'A05'];
      return this.res.m15.filter(item => three.indexOf(item.dis) != -1);
    },

    weightChart (sugweight, weeks) {
      var option = {
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            if (params[0].dataIndex == 0) {
              return params[0].name + ':<br>' + '體重為' + params[0].data + 'kg'
            } else {
              return params[0].name + ':<br>' + '體重改善目標為' + params[0].data + 'kg'
            }
          },
        },
        grid: {
          top: '15%',
          bottom: '14%',
          left: '10%',
          right: '8%'
        },
        xAxis: {
          axisLabel: {
            interval: 0,
            color: '#777F8F'
          },
          boundaryGap: false,
          // splitNumber: 5,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: 'true',
            lineStyle: {
              color: '#f5f5f5'
            }
          },
          data: (() => {
            let lists = []
            weeks.map((item, index) => {
              if (index == 0) {
                item = '當前'
              } else {
                item = '第' + item + '周'
              }
              lists.push(item)
            })
            return lists
          })()
        },
        yAxis: {
          name: 'kg',
          type: 'value',
          axisLabel: {
            color: '#777F8F'
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#f5f5f5'
            }
          }
        },
        series: [
          {
            type: 'line',
            symbol: 'emptyCircle',
            areaStyle: {
              opacity: .2,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0, color: '#6883FB'
              }, {
                offset: 1, color: '#fff'
              }]
              )
            },
            smooth: false,
            data: sugweight
          }
        ],
        color: ['#6883FB', '#65D448']
      }
      this.drawChat('.weight_chart', option);
    },
    whrChart (sugwhr, weeks) {
      var option = {
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            if (params[0].dataIndex == 0) {
              return params[0].name + ':<br>' + '腰臀比為' + params[0].data
            } else {
              return params[0].name + ':<br>' + '腰臀比改善目標為' + params[0].data
            }
          },
        },
        grid: {
          top: '15%',
          bottom: '14%',
          left: '10%',
          right: '8%'
        },
        xAxis: {
          axisLabel: {
            interval: 0,
            color: '#777F8F'
          },
          boundaryGap: false,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: 'true',
            lineStyle: {
              color: '#f5f5f5'
            }
          },
          data: (() => {
            let lists = []
            weeks.map((item, index) => {
              if (index == 0) {
                item = '當前'
              } else {
                item = '第' + item + '周'
              }
              lists.push(item)
            })
            return lists
          })()
        },
        yAxis: {
          name: '',
          type: 'value',
          axisLabel: {
            color: '#777F8F'
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#f5f5f5'
            }
          }
        },
        series: [
          {
            type: 'line',
            symbol: 'emptyCircle',
            areaStyle: {
              opacity: .2,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0, color: '#6883FB'
              }, {
                offset: 1, color: '#fff'
              }]
              )
            },
            data: sugwhr
          }
        ],
        color: ['#6883FB', '#65D448']
      }
      this.drawChat('.whr_chart', option);
    },

    // 當前模塊顯示圖表
    showChart () {
      this.$nextTick(() => {
        switch (this.active) {
          case 'biom': //常見疾病風險倍率
            this.biomClassify(this.active);//生化指標評估表格
            break;
          case 'core': //常見疾病風險倍率
            this.res.m15 ? this.BiochemicalChart(this.res.m15) : '';
            break;
          case 'total': //總體健康評估和生命預測
            this.totalChart(this.res.m01);
            break;
          case 'costs': //醫療費用預測
            this.costsChart(this.res.m10.person_yearsfee, (this.res.m10.compare_yearsfee && this.res.base.categ != "HEA1") ? this.res.m10.compare_yearsfee : []);
            break;
          case 'improve': //健康管理和改善方案
            this.res.m13 ? this.biomClassify(this.active) : '';//改善生化指標
            this.res.m12 ? this.weightChart(this.res.m12.sugweight, this.res.m12.weeks) : '';
            this.res.m12 ? this.whrChart(this.res.m12.sugwhr, this.res.m12.weeks) : '';
            break;
        }
      })
    },

    // 圖表列表
    BiochemicalChart (data) {
      let list = [];
      let illList = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].sick && data[i].sick == 1) {
          illList.push(data[i])
          data[i].rate = 0.001
        }
      }
      var option = {
        grid: {
          top: 60,
          bottom: 30,
          left: '22%',
          right: '15%'
        },
        legend: {
          show: false
        },
        xAxis: {
          type: 'value',
          show: false,
          splitLine: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: false
          },
          max: function (value) {
            return value.max + 2;
          }
        },
        yAxis: [
          {
            name: '疾病類別',
            boundaryGap: false,
            nameGap: 28,
            offset: 0,
            nameTextStyle: {
              color: '#777F8F'
            },
            type: 'category',
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            data: []
          }, {
            name: '患病風險倍率',
            boundaryGap: false,
            nameGap: 28,
            nameTextStyle: {
              color: '#777F8F'
            },
            type: 'category',
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLine: {
              show: false
            },
            data: []
          }
        ],
        visualMap: {
          type: 'piecewise',
          orient: 'horizontal',
          left: 'center',
          min: 10,
          max: 100,
          show: false,
          pieces: [{
            gt: 0,
            lt: 0.002,
            color: '#F25364'
          }, {
            gte: 0.002,
            lt: 1,
            color: '#65D448'
          },
          {
            gt: 1,
            lte: 2,
            color: 'rgba(255, 204, 26, 1)'
          }, {
            gt: 2,
            color: '#F25364'
          },],
          // Map the score column to color
          dimension: 0,
        },
        series: [
          {
            type: 'bar',
            barWidth: 6,
            itemStyle: {
              color: 'rgba(31, 211, 169, 1)',
              barBorderRadius: 4
            },
            // label:{
            // 	show:false
            // },
            label: {
              show: true,
              position: 'right',
              // position: 'bottom',
              textStyle: {
                fontSize: 12,
                fontWeight: '700',
              },
              formatter: function (params) {
                let value = list.indexOf(params.dataIndex) > -1 ? '患病風險倍率: <' + params.value : '患病風險倍率：' + params.value
                for (let i = 0; i < illList.length; i++) {
                  if (params.dataIndex == (data.length - i - 1)) {
                    value = '根據你填寫的問卷內容，你已患病'
                  }
                }
                return value
              }
            },
            markLine: {
              silent: true,
              label: {
                formatter: '1.0'
              },
              symbol: 'none',
              data: [{
                xAxis: 1
              }],
              lineStyle: {
                color: '#F25364'
              }
            },
            data: []
          }
        ]
      }
      data = [...data].reverse();
      // 風險倍率從大到小排序
      // data.sort((a,b) => a.rate-b.rate);
      //超出1.0疾病類型字體顏色變深
      for (var i = 0; i < data.length; i++) {
        if (data[i].tag) {
          list.push(i)
        }
        // option.yAxis[1].data.push(data[i].tag ? data[i].tag : data[i].rate);// 疾病類型倍率數組
        option.series[0].data.push(data[i].rate);// 疾病風險倍率
        var yName = {
          value: data[i].devg,
          textStyle: {
            color: data[i].rate >= 1 ? '#40444D' : data[i].rate == 0.001 ? '#F25364' : '#777F8F',
            fontWeight: data[i].rate > 1 ? 'bold' : 'normal'
          }
        };
        option.yAxis[0].data.push(yName);
      }
      this.drawChat('.biom-chart', option);
    },//常見疾病風險倍率

    totalChart (data) {
      //取當前年齡後一年到預期壽命年限的生命曲線數據
      var section = Math.round(data.pre_rem);// 年齡區間
      data.rates_ages = data.rates_ages.slice(0, section);// 年齡
      data.heal_rates = data.heal_rates.slice(0, section);// 健康率
      // data.lift_rates = data.lift_rates.slice(0,section);// 存活率
      data.lost_heal_ratio = data.lost_heal_ratio.slice(0, section);// 失能率

      var option = {
        title: {
          text: '在未來' + section + '年間，' + data.rates_ages[0] + '~' + (parseInt(data.rates_ages[0]) + parseInt(section) - 1) + '歲的生命曲線',
          textStyle: {
            color: 'rgb(87, 93, 105)',
            fontSize: 14,
            fontWeight: '400'
          },
        },
        legend: {
          data: ['健康率', '失能率'],
          icon: 'roundRect',
          textStyle: {
            color: '#777F8F',
            fontSize: 12
          },
          top: 22,
          left: 0,
          itemWidth: 6,
          itemHeight: 6,
          itemGap: 6
        },
        grid: {
          left: 40,
          bottom: 30
        },
        color: ['rgba(92, 212, 162, 1)', 'rgba(191, 203, 255, 1)'],
        backgroundColor: '#fff',
        tooltip: {
          trigger: 'axis',
          formatter: '{b}<br>{a}: {c}%<br>{a1}: {c1}%',
          backgroundColor: '#6883FB',
          extraCssText: 'text-align: left;'
        },
        xAxis: {
          type: 'category',
          axisLine: {
            show: false
          },
          axisLabel: {
            color: '#777f8f',
            fontWeight: '300'
          },
          boundaryGap: false,
          axisTick: {
            show: false
          },
          nameLocation: 'start',
          data: (function () {
            for (var i = 0, ages = []; i < data.rates_ages.length; i++) {
              ages.push(data.rates_ages[i] + '歲');
            }
            return ages;
          })()
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false
          },
          axisLabel: {
            formatter: '{value}%',
            color: '#777f8f',
            fontWeight: '300'
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#E7E9EE'
            }
          }
        },
        series: [
          {
            name: '健康率',
            type: 'bar',
            data: data.heal_rates,
            barMinWidth: 1,
            barMaxWidth: 8,
            // lineStyle: {
            // 	width: 3
            // },
            // symbol: 'none',
            // smooth: true
          },
          {
            name: '失能率',
            type: 'bar',
            data: data.lost_heal_ratio,
            barMinWidth: 1,
            barMaxWidth: 8,
            // lineStyle: {
            // 	width: 3
            // },
            // symbol: 'none',
            // smooth: true
          }
        ]
      }
      this.drawChat('.total-chart', option);
    },// 總體健康評估和生命預測

    costsChart (tenYears, tenYearsGroup) {
      var option = {
        // title: {
        // 	text: '未來'+ tenYears.length +'年主要醫療費用演化趨勢',
        // 	textStyle: {
        // 		color: '#40444D',
        // 		fontSize: 12
        // 	},
        // 	bottom: 15,
        // 	left: 'center'
        // },
        legend: {
          orient: 'horizontal',
          data: ['你的醫療費用預測', '同族群的醫療費用預測'],
          icon: 'roundRect',
          textStyle: {
            color: '#777F8F',
            fontSize: 12
          },
          // // top: 10,
          bottom: 10,
          // left: '40%',
          itemWidth: 8,
          itemHeight: 8,
          itemGap: 10
        },
        backgroundColor: '#fff',
        grid: {
          left: '18%',
          right: 0
        },
        tooltip: {
          trigger: 'axis',
          formatter: tenYearsGroup.length > 0 ? function (params) {
            if (params.length == 1) {
              return `第${params[0].axisValue}年<br>${params[0].seriesName}: ${params[0].value}元`
            } else {
              return `第${params[0].axisValue}年<br>${params[0].seriesName}: ${params[0].value}元<br>${params[1].seriesName}: ${params[1].value}元`
            }
          } : '<br>第{b0}年',
          backgroundColor: '#FCFDFF',
          confine: true,
          textStyle: {
            color: '#666',
            fontSize: 12,
            fontWeight: 300
          },
          extraCssText: 'box-shadow: 0px 10px 20px 0px rgba(136,144,152,0.14);text-align: left;'
        },
        xAxis: {
          type: 'category',
          nameTextStyle: {
            color: '#777F8F'
          },
          axisLabel: {
            color: '#777F8F'
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          data: (() => {
            var x = [];
            for (var i = 0; i < tenYears.length; i++) {
              x.push(i + 1);
            }
            return x;
          })()
        },
        yAxis: {
          name: '￥      ',
          nameTextStyle: {
            color: '#777F8F'
          },
          axisLabel: {
            color: '#777F8F'
          },
          axisLine: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#f5f5f5'
            }
          },
          axisTick: {
            show: false
          },
        },
        series: [
          {
            type: 'bar',
            name: '你的醫療費用預測',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(
                0, 0, 0, 1,//漸變色在下面修改，這裏是透明度
                [{
                  offset: 0,
                  color: 'rgba(83, 131, 255, 1)',
                  borderRadius: 8
                },
                {
                  offset: 1,
                  color: 'rgba(161, 188, 255, 1)',

                }
                ]
              ),
              barBorderRadius: 8
            },
            barWidth: 8,
            data: []
          },
          {
            type: 'bar',
            name: '同族群的醫療費用預測',
            itemStyle: {
              normal: {
                color: '#E6E8EB',
                barBorderRadius: 8
              },
              emphasis: {
                color: '#E6E8EB',
                opacity: '0.8',
                barBorderRadius: 8
              },
            },
            barWidth: 8,
            data: [],

          }
        ]
      }
      // 是否有同族群展示
      if (tenYearsGroup) {

      }
      if (tenYearsGroup.length < 1) {
        option.legend.data.pop();
        option.series.pop();
        option.tooltip.formatter += '<br>{a0}:{c0}元';
      } else {
        for (var p = 0; p < tenYearsGroup.length; p++) {
          // 費用計算
          option.series[1].data.push(tenYearsGroup[p]);
        }
        // option.tooltip.formatter += '<br>{a0}:{c0}元<br>{a1}:{c1}元';
      }
      for (var q = 0; q < tenYears.length; q++) {
        // 費用計算
        option.series[0].data.push(tenYears[q]);
      }
      this.drawChat('.costs-chart', option);
    },// 醫療費用預測  參數一：十年費用預測  參數二：同族費用預測(可能為空)

    illnessChart (el, person, compare) {
      var option = {
        tooltip: {
          trigger: 'axis',
          formatter: '{b}'
        },
        legend: {
          data: ['個人患病概率', '同族群患病概率'],
          icon: 'roundRect',
          textStyle: {
            color: '#777F8F',
            fontSize: 12
          },
          itemWidth: 10,
          itemHeight: 4,
          itemGap: 20
        },
        xAxis: {
          boundaryGap: false,
          axisLabel: {
            color: '#777F8F',
            interval: 0
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: 'true',
            lineStyle: {
              color: '#f5f5f5'
            }
          },
          data: (function () {
            var arr = [];
            for (var i = 0; i < person.length; i++) {
              if (person.length == 3) {
                arr.push('第' + (i + 3) + '年');
              } else {
                arr.push('第' + (i + 1) + '年');
              }
            }
            return arr;
          })()
        },
        yAxis: {
          name: '%',
          type: 'value',
          axisLabel: {
            color: '#777F8F'
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#f5f5f5'
            }
          }
        },
        series: [
          {
            name: '個人患病概率',
            type: 'line',
            data: person
          },
          {
            name: '同族群患病概率',
            type: 'line',
            data: []
          }
        ],
        color: ['#6883FB', '#65D448']
      };
      option.tooltip.formatter += '<br>個人患病概率:{c}%';
      if (compare && compare.length > 0) {
        option.tooltip.formatter += '<br>同族群患病概率:{c1}%';
        option.series[1].data = compare;
      } else {
        option.legend.data.pop();
        option.series.pop();
      }
      this.drawChat(el, option);
    },//未來疾病風險預測 參數：1：疾病列表下標(用了區分圖標class) 2:疾病名稱 3：疾病列表數據 4：同族群列表數據

    cancerChart (el, name, data) {
      var option = {
        tooltip: {
          trigger: 'axis',
          formatter: '{b}的疾病風險<br>你患' + name + '的倍率為:{c}倍'
        },
        xAxis: {
          axisLabel: {
            color: '#777F8F'
          },
          boundaryGap: false,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: 'true',
            lineStyle: {
              color: '#f5f5f5'
            }
          },
          data: ['未來5年', '未來10年', '未來15年', '未來20年']
        },
        yAxis: {
          name: '倍',
          type: 'value',
          axisLabel: {
            color: '#777F8F'
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#f5f5f5'
            }
          }
        },
        series: [
          {
            type: 'line',
            symbol: 'none',
            areaStyle: {
              opacity: .2,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0, color: '#6883FB'
              }, {
                offset: 1, color: '#fff'
              }]
              )
            },
            data: data
          }
        ],
        color: ['#6883FB', '#65D448']
      }
      this.drawChat(el, option);
    },//癌症風險圖表

    drawChat (el, option) {
      window[el] = echarts.init(document.querySelector(el));
      // option.animationDuration = 1000;
      window[el].setOption(option, true);
      window.onresize = window[el].resize;
    },// 繪製圖表通用
    getBiomClass (item) {
      switch (item.cmp_p) {
        case "05": case "07": case "06": case "01":
          return "bomi_item_group c-high"
        case "03": case "02": case "04":
          return "bomi_item_group qjc-c-primary"
        case "08":
          return "bomi_item_group c-nice"
        default:
          return ""
      }
    }
  }
}
</script>

<style scoped>
.person>>>.van-grid-item__content {
  padding: 0;
}

.total>>>.van-grid-item__content {
  background: #F5F6FA;
  border-radius: 0.08rem;
  height: 2.26rem;
  padding: 0.24rem 0.2rem;
}

.tip_p {
  position: relative;
  padding-left: 0.1rem;
  text-align: left;
}

.tip_p::before {
  position: absolute;
  content: '';
  top: 0.12rem;
  left: -0.04rem;
  width: 0.08rem;
  height: 0.08rem;
  border-radius: 50%;
  background-color: #6883FB;
}

.three_list .costs_top {
  padding: 0.24rem 0.24rem 0;
  margin-bottom: 0.1rem;
}

.three_list .costs_top::before {
  top: 0.36rem;
  left: 0;
}

.tip_p_wrap {
  padding: 0.24rem;
  text-align: left;
}
</style>
<style lang="scss" scoped>
@import "../../assets/iconfont/iconfont.css";

.van-nav-bar {
  background-color: #F5F7FA;
}

.baijin-report {
  position: relative;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .qjc-nav-bar {
    flex: 0 0 auto;
  }

  >div {
    width: 100%;
  }
}

.result {
  flex: 1;
  color: #777F8F;
  background-color: #fff;
  overflow: auto;

  &::before {
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    width: 100%;
    // height: 4.33rem;
  }

  // 各套餐文字顏色
  $health: #44B46E; // 健康
  $subhealth: #D1B83C; // 亞健康
  $medical: #CC5656; // 醫療需求

  &.type-color1 {

    // 健康
    &::before {
      background: linear-gradient(#F5F7FA, rgba(255, 255, 255, 0)) // background: linear-gradient(0deg, #F5F7FA 0%, rgba(255, 255, 255, 0) 100%);
        // background: linear-gradient(0deg, rgba(235, 247, 239, 0) 0%, #EBF7EF 100%);
    }

    .mlev {
      color: $health;
    }

    .t-belong {
      span {
        color: $health;
      }
    }
  }

  &.type-color2 {

    // 亞健康
    &::before {
      background: linear-gradient(#F5F7FA, rgba(255, 255, 255, 0)) // background: linear-gradient(0deg, #F5F7FA 0%, rgba(255, 255, 255, 0) 100%);
        // background: linear-gradient(0deg, rgba(247, 244, 235, 0) 0%, #F7F4EB 100%);
    }

    .mlev {
      color: $subhealth;
    }

    .t-belong {
      span {
        color: $subhealth;
      }
    }
  }

  &.type-color3 {

    // 醫療需求
    &::before {
      background: linear-gradient(#F5F7FA, rgba(255, 255, 255, 0)) // background: linear-gradient(0deg, #F5F7FA 0%, rgba(255, 255, 255, 0) 100%);
        // background: linear-gradient(0deg, rgba(247, 235, 235, 0) 0%, #F7EBEB 100%);
    }

    .mlev {
      color: $medical;
    }

    .t-belong {
      span {
        color: $medical;
      }
    }
  }

  // 個人信息

  .infomation-bg {
    position: relative;
    margin-bottom: 0.4rem;
    z-index: 999;
  }

  .infomation-new {
    position: relative;
    margin: 0 0.24rem;
    padding-top: 0.24rem;
    overflow: hidden;
    box-shadow: 0px 0.06rem 0.5rem 0px #edf1f6;


    &::after {
      // content: '';
      // display: block;
      // clear: both;
      content: '';
      width: 260%;
      height: 100%;
      position: absolute;
      left: -80%;
      top: 0;
      z-index: -1;
      border-radius: 0 0 50% 50%;
      background: #ffffff;
      overflow: hidden;
      // box-shadow: 0px 0.25rem 0.5rem 0px #EDF1F6;
      box-shadow: 0 0.06rem 0.5rem 0 #edf1f6;
    }

    .circle-wrap {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;

      .circle-tip {
        position: absolute;
        bottom: 0;
        height: 0.5rem;
        line-height: 0.5rem;
        padding: 0 0.1rem;
        font-size: 0.2rem;
        color: #777F8F;
        border-radius: 0.2rem;
        background-color: #ffffff;
        z-index: 3;
        // transform: rotate(180deg);
      }
    }

    .circle-dashed {
      position: absolute;
      z-index: 2;
      width: 2.5rem;
      height: 2.5rem;
      // background: linear-gradient(to bottom, #ff1481, #ff5d3e);
      border: 0.1rem dashed #ffffff;
      border-radius: 50%;
      transform: rotate(180deg);

    }

    .infomation-tip {
      padding-bottom: .1rem;

      p {
        font-size: 0.2rem;
        color: #777F8F;
      }

      span {
        color: #6681FA;
      }
    }

    .danger {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 0.36rem;
      width: 100%;
      transform: rotate(180deg);

      .mlev {
        transform: rotate(180deg);

        span {
          font-size: 0.48rem;
        }
      }
    }

    &>div {
      p {
        margin-bottom: 0.24rem;
      }

      ul {
        display: flex;
        flex-wrap: wrap;
        width: 4.1rem;

        li {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 1.9rem;
          height: 0.56rem;
          background-color: #F5F6FA;
          border-radius: 0.28rem;
          margin-bottom: 0.16rem;
          margin-right: 0.24rem;
        }
      }
    }

    li:nth-child(3n) {
      margin-right: 0;
    }

    .hint {
      font-size: 0.2rem;
      color: #777F8F;
      margin-top: 0.06rem;
    }

    .circle-level {
      font-size: 0.48rem;
      font-weight: 800;
      color: #40444D;
    }

    .circle-level-text {
      font-size: 0.24rem;
      color: #777F8F;
    }

    .shape-tag-wrap {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      width: 100%;
      padding: 0.47rem 0.4rem 0;
      align-content: space-around;
      justify-content: center
    }

    .tag-b {
      color: #40444D;
    }

  }




  .infomation {
    position: relative;
    margin: 0 0.24rem 0.24rem;
    padding-top: 0.36rem;
    border-radius: 0.1rem;
    background-color: #fff;

    &::after {
      content: '';
      display: block;
      clear: both;
    }

    .danger {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 0.36rem;

      .mlev {
        span {
          font-size: 0.48rem;
        }
      }
    }

    &>div {
      p {
        margin-bottom: 0.24rem;
      }

      ul {
        display: flex;
        flex-wrap: wrap;
        width: 4.1rem;

        li {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 1.9rem;
          height: 0.56rem;
          background-color: #F5F6FA;
          border-radius: 0.28rem;
          margin-bottom: 0.12rem;
          margin-right: 0.12rem;
        }
      }
    }

    .hint {
      font-size: 0.2rem;
      color: #777F8F;
      margin-top: 0.06rem;
    }
  }

  .person_wrap {
    padding: 0 0.24rem;
    margin-bottom: 0.16rem;
  }

  .person {
    padding: 0.4rem 0.1rem 0.4rem;
    border-radius: 0.12rem;
    border: 1px solid #d3d5de;


    dl {
      margin: 1rem auto;

      dt {
        width: 1.7rem;
        color: #999999;
      }

      b {
        font-size: 0.4rem;
      }
    }
  }

  // 結果列表
  .list {
    position: relative;
    width: 100%;
    height: 100%;
    background-color: #F5F7FA;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    >div {
      width: 100%;
    }

    .type-header-select {
      flex: 0 0 auto;
    }

    .type-content {
      flex: 1;
      overflow: auto
    }

    //滑動切換
    .van-swipe {
      position: relative;
      width: 100%;
      height: 100%;

      .van-swipe-item {
        height: 100%;
        min-height: 1px;
        overflow-y: auto;
      }
    }

    // 生化指標評估
    .biom {
      padding: 0.24rem;

      p {
        font-size: 0.2rem;
        color: #6A7180;
        line-height: 0.27rem;
        margin-bottom: 0.48rem;
        margin-top: 0.2rem;
      }

      .bomi_top_cell {
        display: flex;
        align-items: center;
        padding: 0 0.12rem;
        margin: 0.24rem 0 0.08rem;
      }

      .bomi_title {
        flex: 1;
        color: rgba(59, 69, 73, 1);
        font-family: PingFang SC;
        font-weight: 600;
        font-size: 0.26rem;
        line-height: 0.34rem;
      }

      .bomi_res {
        flex: 1;
        color: rgba(59, 69, 73, 1);
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 0.26rem;
        line-height: 0.34rem;
      }

      .bomi_v {
        // flex: 1;
        color: rgba(59, 69, 73, 1);
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 0.26rem;
        line-height: 0.34rem;
      }

      .bomi_btn_v {
        // flex: 1;
        width: 1.2rem !important;
        color: rgba(59, 69, 73, 1);
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 0.26rem;
        line-height: 0.34rem;
        text-align: center;
      }

      .bomi_lc {
        flex: 1;
        color: rgba(59, 69, 73, 1);
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 0.26rem;
        line-height: 0.34rem;
      }

      .bomi_group {
        // flex: 1;
        color: rgba(59, 69, 73, 1);
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 0.26rem;
        line-height: 0.34rem;
      }

      .bomi_item {
        display: flex;
        align-items: center;
        padding: 0.16rem 0.12rem;
        background-color: rgba(244, 246, 252, 1);

        &:nth-child(4) {
          border-radius: 0.08rem 0.08rem 0 0;
        }

        &:nth-child(6) {
          border-radius: 0 0 0.08rem 0.08rem;
        }

        &:nth-child(8) {
          border-radius: 0.08rem 0.08rem 0 0;
        }

        &:nth-child(9) {
          border-radius: 0 0 0.08rem 0.08rem;
        }

        &:nth-child(11) {
          border-radius: 0.08rem 0.08rem 0 0;
        }

        &:nth-child(14) {
          border-radius: 0 0 0.08rem 0.08rem;
        }

        &:nth-child(16) {
          border-radius: 0.08rem 0.08rem 0 0;
        }

        &:nth-child(19) {
          border-radius: 0 0 0.08rem 0.08rem;
        }

        &:nth-child(21) {
          border-radius: 0.08rem 0.08rem 0 0;
        }

        &:nth-child(23) {
          border-radius: 0 0 0.08rem 0.08rem;
        }

        .c-low {
          font-weight: 500;
          color: #3AC316 !important;
        }

        .c-high {
          font-weight: 500;
          color: #FF3131 !important;
        }

        .c-nice {
          font-weight: 500;
          color: #3AC316 !important;
        }

        .qjc-c-primary {
          font-weight: 500;
        }

        .bomi_item_title {
          flex: 1;
          color: rgba(59, 69, 73, 1);
          font-family: PingFang SC;
          font-size: 0.26rem;
          line-height: 0.34rem;
        }

        .bomi_item_res {
          // display: flex;
          flex: 1;
          color: rgba(59, 69, 73, 1);
          font-family: PingFang SC;
          font-size: 0.26rem;
          line-height: 0.34rem;

          span {
            margin-left: 0.08rem
          }
        }

        .bomi_item_v {
          // flex: 1;
          width: 1.2rem !important;
          color: rgba(59, 69, 73, 1);
          font-family: PingFang SC;
          font-size: 0.26rem;
          line-height: 0.34rem;
          text-align: center;

        }

        .bomi_item_group {
          // flex: 1;
          width: 1.2rem !important;
          color: rgba(59, 69, 73, 1);
          font-family: PingFang SC;
          font-size: 0.26rem;
          line-height: 0.34rem;
          text-align: center;
        }
      }



      table {
        font-size: 0.2rem;
        line-height: 0.28rem;
        border-radius: 0.08rem;
        border: 0.01rem solid #D3D5DE;
        overflow: hidden;

        .group-v {
          position: relative;

          &::before {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 2000%;
            border-left: 0.01rem dashed #D3D5DE;
            content: '';
          }
        }

        th,
        li {
          height: 0.67rem;
          padding: 0.2rem 0.15rem;
        }

        li {
          display: flex;
          align-items: center;

          span {
            font-weight: 600;
            margin-right: 0.05rem;
          }
        }

        tr>td:nth-child(2) {
          width: 1.7rem;
        }

        tr>td:nth-child(4),
        tr>td:nth-child(5) {
          width: 1.3rem;
        }

        tr>td:first-child {
          width: 0.45rem;
          padding: 0 0.12rem;
          border-right: 0.01rem solid #D3D5DE;
        }

        tr>td:last-child {
          width: 1.7rem;
          padding-left: 0.15rem;
        }

        tr>th:last-child {
          padding-left: 0.3rem;
        }

        tr:nth-child(even) {
          background-color: #F5F8FC;

          td {
            border-top: 0.01rem solid #D3D5DE;
            border-bottom: 0.01rem solid #D3D5DE;

            &:first-child {
              border-left: 0.01rem solid #D3D5DE;
            }

            &:last-child {
              border-right: 0.01rem solid #D3D5DE;
            }
          }
        }

        .c-low {
          font-weight: 500;
          color: #3AC316;
        }

        .c-high {
          font-weight: 500;
          color: #FF3131;
        }

        .c-nice {
          font-weight: 500;
          color: #3AC316;
        }

        .qjc-c-primary {
          font-weight: 500;
        }
      }

      .chart-t {
        margin: 0.4rem 0 0.24rem;
      }

    }

    .core {
      padding: 0.24rem;

      .biom-chart {
        height: 7.925rem;
        background-color: #F5F8FC;
        border-radius: 0.08rem 0.08rem 0 0;
        margin-top: 0.3rem;
      }
    }

    // 未來健康風險預測
    .health {
      li {
        padding: 0.24rem;
        border-bottom: 0.1rem solid #F5F7FA;

        h3 {
          margin: 0.2rem 0 0.3rem;
        }

        dl {
          background-color: #F5F8FC;
          border-radius: 0.08rem;
          padding: 0.3rem 0;
          line-height: 0.4rem;

          dd {
            span {
              font-size: 0.34rem;
            }
          }
        }

        p {
          margin: 0.24rem 0;
          font-weight: 300;
          line-height: 0.48rem;

          span {
            font-weight: 400;
          }
        }
      }

      // 健康者
      .health1 {
        padding: 0.36rem 0.26rem;

        p {
          font-size: 0.28rem;
          color: #6A7180;
          font-weight: 300;
          line-height: 0.56rem;
          margin-bottom: 0.4rem;
        }

        div {
          display: flex;
          justify-content: space-between;
          background-color: #F5F8FC;
          padding: 0.22rem 0.5rem;
          margin-bottom: 0.28rem;

          dl {
            width: 1.9rem;
            border-radius: 0.08rem;

            b {
              font-size: 0.48rem;
            }

            dt {
              line-height: 0.28rem;
              font-weight: 500;
            }
          }
        }
      }
    }

    // 標題列表
    .list-title {
      height: 0.76rem;
      line-height: 0.75rem;
      display: flex;
      justify-content: flex-start;
      border-bottom: 0.01rem solid #D3D5DE;
      background-color: #F5F7FA;
      overflow-x: auto;

      li {
        padding: 0 0.2rem;
        font-weight: 500;
        background: transparent;
        transition: all .3s;

        &.active {
          color: #fff;
          background: linear-gradient(5deg, #6681FA 0%, #8A9DF7 100%);
        }
      }
    }

    // 總體健康和生命預測
    .total {
      padding: 0.36rem 0.1rem 0.1rem;

      .total-t {
        .van-grid-item {
          p {
            margin-bottom: 1rem;
            height: 0.24rem;
            line-height: 0.24rem;

            b {
              font-weight: 400;
            }
          }

          div {
            display: flex;
            justify-content: space-between;
            align-items: center;

            span {
              font-size: 0.4rem;
            }
          }
        }
      }

      .total_title {
        position: relative;
        padding-left: 0.14rem;
        color: rgba(41, 48, 51, 1);
        font-family: PingFang SC;
        font-weight: 500;
        font-size: 0.36rem;
        line-height: 0.36rem;
        text-align: left;

        &::before {
          position: absolute;
          left: -0.12rem;
          top: 0.12rem;
          content: '';
          width: 0.16rem;
          height: 0.12rem;
          border-radius: 0 0.04rem 0.04rem 0;
          background: rgba(82, 114, 255, 1);
        }
      }

      .total-chart {
        height: 6.43rem;
        margin: 0.2rem 0.1rem;
      }

      .hint {
        padding: 0 0.1rem;
        font-weight: 400;
        line-height: 0.48rem;

        .qjc-c-primary {
          font-weight: 500;
        }
      }


      .total_item {
        position: relative;
        padding: 0.36rem 0.14rem 0.24rem;
        width: 100%;
        margin-top: 0.12rem;
        // background-color: #fff;


        &::before {
          position: absolute;
          top: 0;
          left: -0.1rem;
          content: '';
          width: 7.50rem;
          height: 0.12rem;
          background-color: #f3f4fa;
        }

        .total_item_cell {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;

          .total_item_title {
            color: rgba(41, 48, 51, 1);
            font-family: PingFang SC;
            font-weight: 500;
            font-size: 0.30rem;
            line-height: 0.30rem;
          }

          .total_item_val {
            color: rgba(82, 114, 255, 1);
            font-family: MiSans-Demibold;
            font-size: 0.40rem;
            font-weight: 500;
            line-height: 0.40rem;

            span {
              font-family: PingFang SC;
              font-size: 0.22rem;
              font-weight: 400;
            }
          }
        }

        .total_item_text {
          // color: rgba(87, 93, 105, 1);
          // font-family: PingFang SC;
          // font-size: 0.26rem;
          // line-height: 0.40rem;
          // text-align: left;
          // margin-top: 0.1rem;

          text-align: left;
          font-size: 0.28rem;
          font-weight: 300;
          line-height: 0.56rem;
          color: #6A7180;
          margin-top: 0.1rem;
        }
      }

    }

    // 體型評估
    .bodily {
      padding: 0.24rem 0.24rem 0.8rem;
      background-color: #F5F7FA;

      h4 {
        margin: 0.4rem 0 0.24rem;
        font-weight: 500;
      }

      .res {
        table {
          padding: 0.2rem 0.3rem;
          border-radius: 0.08rem;
          color: #6A7180;

          thead {
            line-height: 0.98rem;

            th {
              font-weight: 400;
              border-bottom: 0.01rem solid #777F8F;

              &.qjc-ftw-b {
                font-weight: 500;
              }

              &:first-child {
                width: 1rem;
                position: relative;
              }
            }

            .BFR-t {
              position: absolute;
              left: 0;
              bottom: 8%;
              text-align: left;
              width: 0.6rem;
              line-height: 0.26rem;
            }

            .BMI-t {
              position: absolute;
              top: 8%;
              right: 0;
              line-height: 0.26rem;

              &:before {
                content: '';
                position: absolute;
                left: -54%;
                bottom: 0;
                transform: rotateZ(45deg);
                width: 0.5rem;
                border-bottom: 0.01rem solid #777F8F;
              }
            }
          }

          tr {
            height: 1.77rem;
          }

          tr>td:first-child,
          thead>th:first-child {
            border-right: 0.01rem solid #777F8F;
          }

          .van-image {
            vertical-align: middle;
            margin-right: 0.1rem;
          }

          .img-hint {
            display: inline-block;
            font-size: 0.2rem;
            width: 0.2rem;
            line-height: 0.28rem;
            vertical-align: middle;
          }
        }
      }

      .targets {
        &>div {
          padding: 0.40rem 0.3rem 0.48rem;
          border-radius: 0.08rem;
          margin-bottom: 0.2rem;
        }

        [class^=hint] {
          height: 0.38rem;
          line-height: 0.38rem;
          padding: 0 0.1rem;
          text-align: center;
          color: #fff;
          font-size: 0.2rem;
          vertical-align: bottom;
          margin-left: 0.12rem;
          border-radius: 0 0.15rem 0.15rem 0;
        }

        .hint-m {
          background-color: #2EE68D;
        }

        .hint-l {
          background-color: #338FFF;
        }

        .hint-h {
          background-color: #FF4D4D;
        }

        .targets-t {
          font-size: 0.38rem;
          line-height: 0.38rem;
          font-weight: bold;
          color: #250A0A;
          margin-bottom: 0.11rem;
        }

        .targets-t-h {
          font-size: 0.28rem;
          font-weight: 300;
          line-height: 0.56rem;
          color: #6A7180;
        }

        .iconyiwen1 {
          color: #B8C0CC;
          font-size: 0.3rem;

          &>div {
            color: #777F8F;
            font-size: 0.24rem;
            bottom: 2em;
            left: -2.05rem;
            width: 4.2rem;
            margin-top: -0.2rem;
            padding: 0.24rem;
            line-height: 0.36rem;
            box-shadow: 0 0.06rem 0.12rem 0 rgba(218, 220, 227, 1);
            border-radius: 0.08rem;
            z-index: 9999;

            .arrow {
              position: absolute;
              bottom: -0.2rem;
              left: 50%;
              z-index: -1;
              width: 0.4rem;
              height: 0.4rem;
              background-color: #fff;
              transform: rotateZ(45deg)translateX(-50%);
            }
          }
        }

        .remark {
          font-size: 0.24rem;
          line-height: 0.48rem;
          color: #6A7180;
          font-weight: 300;
          margin-top: 0.56rem;
        }

        dt {
          margin: 0.56rem 0 0.3rem;
          font-size: 0.32rem;
          font-weight: 500;
          color: #333;
        }

        .group dt {
          margin-top: 0.48rem;
        }

        .line {
          position: relative;
          width: 6.3rem;
          height: 0.52rem;

          ul,
          ol {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;

            li {
              position: relative;
              width: 32%;
              height: 0.06rem;
              z-index: 1;

              &:not(:last-child) {
                margin-right: 0.06rem;
              }
            }
          }

          ul {
            span {
              position: absolute;
              right: 0;
              bottom: -0.5rem;
              transform: translateX(50%);
            }

            li {
              &:nth-child(1) {
                background-color: #338FFF;
              }

              &:nth-child(2) {
                background-color: #2ee68d;
              }

              &:nth-child(3) {
                background-color: #ffbb00;
              }

              &:nth-child(4) {
                background-color: #ff485e;
              }
            }
          }

          ol {
            z-index: 20;

            li:not(:last-child)::after {
              content: '';
              position: absolute;
              top: 0;
              right: -.06rem;
              width: 0.06rem;
              height: 100%;
              background-color: #fff;
              z-index: 20;
            }
          }

          .circle {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 0.06rem;
            transition: all .3s;

            &.step1::before {
              background-color: #338FFF;
              box-shadow: 0 0 0.06rem 0 #338FFF;
            }

            &.step2::before {
              background-color: #2ee68d;
              box-shadow: 0 0 0.06rem 0 #2ee68d;
            }

            &.step3::before {
              background-color: #ffbb00;
              box-shadow: 0 0 0.06rem 0 #ffbb00;
            }

            &.step4::before {
              background-color: #ff485e;
              box-shadow: 0 0 0.06rem 0 #ff485e;
            }

            &::before {
              content: '';
              position: absolute;
              top: -0.07rem;
              left: -0.1rem;
              width: 0.2rem;
              height: 0.2rem;
              border-radius: 50%;
              border: 0.02rem solid #fff;
              box-shadow: 0 0 0.06rem 0 #E1E2E6;
              background-color: #E1E2E6;
              z-index: 100;
            }

            &::after {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background-color: #E1E2E6;
              z-index: 10;
            }
          }
        }

        .BMI .line {

          ul,
          ol {
            li {

              // width: 1.52rem;
              &:nth-child(2) {
                // width: 1.56rem;
              }
            }
          }
        }

        .WHR .line {

          ul,
          ol {
            li {
              width: 3.14rem;

              &:nth-child(2) {
                width: 3.10rem;
              }
            }
          }

          ul {
            li {
              &:nth-child(1) {
                background-color: #2ee68d;
              }

              &:nth-child(2) {
                background-color: #ff485e;
              }
            }
          }

          .circle {
            &.step1::before {
              background-color: #2ee68d;
              box-shadow: 0 0 0.06rem 0 #2ee68d;
            }

            &.step2::before {
              background-color: #ff485e;
              box-shadow: 0 0 0.06rem 0 #ff485e;
            }
          }
        }

        .BFR .line {
          li {
            // width: 2.06rem;
          }
        }

        .BFR .group {
          // overflow: hidden;
        }

        // 不同階段圓形圖標顏色
        .BMI .you .step1 .circle::before,
        .BFR .group .step1 .circle::before {
          box-shadow: 0 0 0.06rem 0 #338fff;
          background: #338fff;
        }

        .BMI .you .step2 .circle::before,
        .WHR .group .step1 .circle::before,
        .BFR .step2 .circle::before {
          box-shadow: 0 0 0.06rem 0 #2ee68d;
          background: #2ee68d;
        }

        .BMI .you .step3 .circle::before,
        .BFR .group .step3 .circle::before {
          box-shadow: 0 0 0.06rem 0 #ffbb00;
          background: #ffbb00;
        }

        .BMI .you .step4 .circle::before,
        .WHR .group .step2 .circle::before {
          box-shadow: 0 0 0.06rem 0 #ff485e;
          background: #ff485e;
        }
      }
    }

    // 醫療費用預測
    .costs {
      padding: 0.48rem 0.24rem 0.8rem;

      ul {
        margin-top: 0.2rem;
      }

      li {
        position: relative;
        padding: 0.35rem 0.48rem 0.4rem 0.35rem;
        border-radius: 0.16rem;
        margin-bottom: 0.24rem;

        .van-image {
          position: absolute;
          right: 0;
          bottom: 0;
          margin-top: 0.08rem;
        }

        &:first-child {
          background-color: rgba(244, 246, 252, 1);

          dd {
            color: rgba(41, 48, 51, 1);
            // color: #F5495B;
          }

          b {}
        }

        &:last-child {
          background: linear-gradient(180deg, rgba(255, 244, 248, 0.9) 0%, rgba(255, 244, 244, 0.9) 100%), rgba(244, 246, 252, 1);

          dd {
            color: rgba(41, 48, 51, 1);
            // color: #4575E5;
          }
        }

        b {
          font-family: MiSans-Demibold;
          font-size: 0.40rem;
          line-height: 0.40rem;
          font-size: 0.48rem;
        }

        dt {
          color: rgba(122, 133, 153, 1);
          font-family: PingFang SC;
          font-size: 0.26rem;
          line-height: 0.40rem;
          margin-top: 0.08rem;
        }
      }

      .costs-chart {
        height: 7.4rem;
      }

      .costs-chart_title {
        position: relative;
        top: 0.40rem;
        z-index: 99;
        color: rgba(41, 48, 51, 1);
        font-family: PingFang SC;
        font-weight: 600;
        font-size: 0.30rem;
        line-height: 0.40rem;
        text-align: left;
      }
    }

    //未來疾病風險預測
    .illness {
      &>div:not(:last-child) {
        border-bottom: 0.16rem solid #F0F2F5;
      }

      h3 {
        font-size: 0.36rem;
        font-weight: 500;
        padding: 0.5rem 0.24rem 0;
      }

      li {
        padding: 0 0.24rem 0.5rem;

        &:not(:last-child) {
          margin-bottom: 0.1rem;
          border-bottom: 0.01rem solid #F5F7FA;
        }

        &:first-child {
          .illness-t {
            padding-top: 0.4rem;
          }
        }

        .illness-t {
          line-height: 0.5rem;
          padding: 0.56rem 0 0.3rem;

          .name {
            font-size: 0.32rem;
          }

          .van-icon {
            vertical-align: middle;
          }
        }

        .chart {
          height: 5.35rem;
        }

        .prob {
          padding: 0.24rem 0;
          background-color: #F5F7FA;
          border-radius: 0.08rem;

          dl {
            line-height: 0.44rem;

            b {
              font-size: 0.34rem;
            }

            dt {
              font-weight: 500;
            }
          }
        }

        .symptom {
          color: #6A7180;
          line-height: 0.48rem;
          font-weight: 300;
          margin-top: 0.3rem;

          span {
            font-weight: 400;
          }
        }

        &>p.qjc-texta-l {
          font-weight: 300;
          line-height: 0.48rem;

          span {
            font-weight: 400;
          }
        }
      }
    }

    //不患病&增壽
    .noSick {
      background-color: #FFF;
      padding: 0.24rem 0.24rem 0.2rem;

      div {
        h3 {
          padding: 0.4rem 0 0.28rem;
        }

        li {
          border-radius: 0.08rem;
          background-color: #F5F7FA;
          margin-bottom: 0.24rem;

          h4 {
            padding: 0.3rem 0.27rem;
          }

          div {
            padding-bottom: 0.3rem;

            dl {
              line-height: 0.4rem;
            }
          }

          p {
            height: 0.9rem;
            line-height: 0.9rem;
            border-top: 0.04rem solid #fff;
          }
        }
      }
    }

    // 健康管理和改善方案
    .improve {
      padding: 0 0.24rem 2rem;

      .program-res {
        display: flex;
        justify-content: space-between;
        font-size: 0.2rem;
        margin: 0.4rem 0 0.6rem;
        padding: 0 !important;
        background-color: #fff !important;
      }

      .improve-body {
        margin-bottom: 0.6rem;

        .target {
          h3 {
            padding: 0.5rem 0 0.3rem;
          }

          &>div {
            display: flex;
            justify-content: space-between;
            padding: 0.24rem 0.28rem;
            background-color: #F5F8FC;
            border-radius: 0.08rem;
            margin-bottom: 0.24rem;

            dt {
              margin-bottom: 0.36rem;
            }

            span {
              font-size: 0.48rem;
            }

            .van-image {
              // margin-top: 0.98rem;
              margin: auto;
            }
          }
        }

        .program {
          h4 {
            margin-top: 0.8rem;
          }

          .program-res {
            display: flex;
            justify-content: space-between;
            font-size: 0.2rem;
            margin: 0.4rem 0 0.6rem;
          }

          &>div>p {
            font-size: 0.2rem;
            color: #6A7180;
            line-height: 0.3rem;
            margin: 0.1rem 0;
          }

          .eat {
            li {
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 0.12rem 0.24rem;
              // height: 1.02rem;
              background-color: #F5F8FC;
              border-radius: 0.08rem;
              margin-bottom: 0.12rem;

              .van-image {
                vertical-align: text-top;
              }

              b {
                font-size: 0.2rem;
                color: #6A7180;

                span {
                  font-size: 0.28rem;
                }
              }
            }
          }

          .sport {
            table {
              $border: 0.02rem solid #F0F2F5;

              font-size: 0.2rem;
              color: #333;
              border-left: $border;
              border-top: $border;

              th {
                font-weight: normal;
                background-color: #EEF4FF;
                line-height: 0.58rem;
                padding: 0 0.12rem;
              }

              td {
                line-height: 0.94rem;
                padding: 0 0.12rem;
                border-bottom: $border;
                border-right: $border;

                span {
                  font-weight: bold;
                  font-size: 0.28rem;
                }
              }
            }

            .symptom {
              font-size: 0.2rem;
              line-height: 0.32rem;
              margin: 0.24rem 0;
            }
          }
        }
      }

      .improve-biom {
        // margin-top: 0.6rem;

        .c-danger {
          color: #FF3131;
        }

        h3 {
          // margin-bottom: 0.06rem;
          padding: 0.4rem 0 0.28rem;
        }

        .improve-table {
          width: 100%;

          @media screen and (max-width: 374px) {
            overflow-x: auto;
          }
        }

        table {
          $border2: 0.01rem solid #F5F5F5;
          font-size: 0.2rem;
          margin-top: 0.28rem;
          margin-bottom: 0.1rem;
          border: $border2;

          td {
            padding: 0.2rem 0.15rem;
          }

          li {
            padding: 0.2rem 0;
            border-bottom: $border2;
          }

          thead td {
            padding: 0.2rem 0.15rem;
            border-bottom: $border2;
          }

          tr:not(:last-child) td {
            border-bottom: $border2;
          }

          tr>td.left-side {
            width: 0.42rem;
            padding: 0.1rem;
            border-right: $border2;
          }

          .iconfont {
            margin-right: 0.04rem;
          }
        }

        .iconfont {
          font-size: 0.2rem;
        }

        .symptom {
          .iconfont {
            margin-right: 0.5rem;
          }
        }
      }
    }
  }
}

.branch {
  width: 100%;
  padding: 0.24rem;
  background-color: #fff;
}

.branch_score {
  position: relative;
  margin-bottom: 0.16rem;
}

.branch_score .branch_content {
  padding-top: 0.88rem;
  border-radius: 0.12rem;


  .arrow {
    position: absolute;
    top: -0.02rem;
    left: 0.86rem;
    z-index: 4;
    width: 0.4rem;
    height: 0.4rem;
    background-color: #fff;
    transform: rotateZ(45deg)translateX(-50%);
  }
}

.branch_item_title {
  position: absolute;
  top: 0;
  left: -0.02rem;
  display: flex;
  align-items: center;
  width: 2.2rem;
  height: 0.66rem;
  padding-bottom: 0.08rem;
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 0.32rem;
  padding: 0 0.24rem 0.08rem;
  color: #fff;
  background: url(../../assets/images/result_score_title.png);
  background-size: 100% 100%;
  // box-shadow: 0px -2px 6px rgba(56, 81, 130, 0.25) inset;
}

.branch_sangao_title {
  position: absolute;
  top: 0;
  left: -0.02rem;
  display: flex;
  align-items: center;
  width: 4.9rem;
  height: 0.66rem;
  padding-bottom: 0.08rem;
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 0.32rem;
  padding: 0 0.24rem 0.08rem;
  color: #fff;
  background: url(../../assets/images/score_title_bg2.png);
  background-size: 100% 100%;
}

.branch_dl_title {
  position: absolute;
  top: 0;
  left: -0.02rem;
  display: flex;
  align-items: center;
  width: 5.8rem;
  height: 0.66rem;
  padding-bottom: 0.08rem;
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 0.32rem;
  padding: 0 0.24rem 0.08rem;
  color: #fff;
  background: url(../../assets/images/score_title_bg3.png);
  background-size: 100% 100%;
}

.score_info {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  height: 1.30rem;
  color: rgba(59, 69, 73, 1);
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 0.28rem;
  background: rgba(242, 247, 255, 1);
  border-radius: 0.12rem;
}

.score_info_top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  width: 100%;
  height: 1.30rem;
  color: rgba(59, 69, 73, 1);
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 0.28rem;
  background: rgba(242, 247, 255, 1);
  border-radius: 0.12rem;
  text-align: left;
  padding: 0.24rem 0.32rem;
}

.score_info_top::before {
  content: "";
  width: 0;
  height: 0;
  border: 0.2rem solid rgba(242, 247, 255, 1);
  border-color: rgba(242, 247, 255, 1) transparent transparent transparent;
  position: absolute;
  bottom: -0.36rem;
  left: var(--infoLeft);
}

.score_info_top_info {
  display: flex;
  align-items: flex-end;
}

.score_info_top_btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.36rem;
  height: 0.56rem;
  border-radius: 0.40rem;
  color: rgba(255, 255, 255, 1);
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 0.22rem;
  background: linear-gradient(5.18deg, rgba(102, 129, 250, 1) 3.09%, rgba(148, 168, 255, 1) 95.17%);
}

.score_info::before {
  content: "";
  width: 0;
  height: 0;
  border: 0.2rem solid rgba(242, 247, 255, 1);
  border-color: rgba(242, 247, 255, 1) transparent transparent transparent;
  position: absolute;
  bottom: -0.36rem;
  left: var(--infoLeft);
}

.score_line {
  position: relative;
  width: 100%;
  height: 0.12rem;
  border-radius: 0.5rem;
  margin-top: 0.3rem;
  background-color: rgb(219, 228, 242);
  box-shadow: 0 0.2rem 0.2rem rgba(81, 159, 232, 0.15) inset;
}

.score_line::before {
  content: '0';
  position: absolute;
  top: 0.2rem;
  left: 0;
  color: rgba(108, 130, 168, 1);
  font-family: PingFang SC;
  font-size: 0.24rem;
  line-height: 0.22rem;
}

.score_one {
  position: absolute;
  width: 59%;
  height: 0.12rem;
  border-radius: 0.5rem 0 0 0.5rem;
  background-color: rgba(254, 90, 110, 1);
  box-shadow: 0 0 0.05rem rgba(171, 245, 255, 0.5) inset;
}

.score_one_bg {
  position: absolute;
  width: 59%;
  height: 0.12rem;
  border-radius: 0.5rem 0 0 0.5rem;
  // background-color: rgba(254, 90, 110, 1);
  // box-shadow: 0 0 0.05rem rgba(171, 245, 255, 0.5) inset;
  // border-right: 0.08rem solid #fff;
}

.score_one_bg::after {
  content: '59';
  position: absolute;
  top: 0.2rem;
  right: -0.12rem;
  color: rgba(108, 130, 168, 1);
  font-family: PingFang SC;
  font-size: 0.24rem;
  line-height: 0.22rem;
}

.score_line_top {
  width: 100%;
  height: 0.12rem;
  border-radius: 0.5rem;
  background-color: rgb(219, 228, 242);
  box-shadow: 0 0.2rem 0.2rem rgba(81, 159, 232, 0.15) inset;
}

.score_d1 {
  position: absolute;
  left: 58%;
  width: 0.08rem;
  height: 0.12rem;
  background-color: #fff;
  z-index: 99;
}

.score_d2 {
  position: absolute;
  left: 88%;
  width: 0.08rem;
  height: 0.12rem;
  background-color: #fff;
  z-index: 99;
}

.score_circle1 {
  position: absolute;
  top: -0.06rem;
  left: 0;
  width: 0.22rem;
  height: 0.22rem;
  border-radius: 50%;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 0.02rem 0.04rem rgba(165, 209, 149, 1);
  z-index: 100;
}

.score_circle2 {
  position: absolute;
  top: -0.06rem;
  left: 0;
  width: 0.22rem;
  height: 0.22rem;
  border-radius: 50%;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 0.02rem 0.04rem rgba(223, 202, 149, 1);
  z-index: 100;
}

.score_circle3 {
  position: absolute;
  top: -0.06rem;
  left: 0;
  width: 0.22rem;
  height: 0.22rem;
  border-radius: 50%;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 0.02rem 0.04rem rgba(223, 171, 154, 1);
  z-index: 100;
}

.score_two {
  position: absolute;
  width: 30%;
  left: 59%;
  height: 0.12rem;
  // border-radius: 0.5rem 0 0 0.5rem;
  background-color: rgba(255, 204, 26, 1);
  box-shadow: 0 0 0.05rem rgba(171, 245, 255, 0.5) inset;
  // border-right: 0.08rem solid #fff;
}

.score_two_bg {
  position: absolute;
  width: 30%;
  left: 59%;
  height: 0.12rem;
}

.score_two_bg::after {
  content: '89';
  position: absolute;
  top: 0.2rem;
  right: -0.12rem;
  color: rgba(108, 130, 168, 1);
  font-family: PingFang SC;
  font-size: 0.24rem;
  line-height: 0.22rem;
}

.score_three_bg {
  position: absolute;
  width: 11%;
  left: 89%;
  height: 0.12rem;
  border-radius: 0 0.5rem 0.5rem 0;
  // background-color: rgb(31, 211, 169);
  // box-shadow: 0 0 0.05rem rgba(171, 245, 255, 0.5) inset;
}

.score_three {
  position: absolute;
  width: 11%;
  left: 89%;
  height: 0.12rem;
  border-radius: 0 0.5rem 0.5rem 0;
  background-color: rgb(31, 211, 169);
  box-shadow: 0 0 0.05rem rgba(171, 245, 255, 0.5) inset;
}

.score_three_bg::after {
  content: '100';
  position: absolute;
  top: 0.2rem;
  right: 0rem;
  color: rgba(108, 130, 168, 1);
  font-family: PingFang SC;
  font-size: 0.24rem;
  line-height: 0.22rem;
}

.score_text {
  color: rgba(106, 113, 128, 1);
  font-family: PingFang SC;
  font-size: 0.24rem;
  line-height: 0.36rem;
  text-align: left;
  margin-top: 0.5rem;
}

.branch_course {
  margin-bottom: 0.16rem;
}

.branch_header {
  width: 100%;
  height: 0.92rem;
  color: rgba(87, 93, 105, 1);
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 0.3rem;
  display: flex;
  align-items: center;
  padding: 0 0.24rem;
  border-radius: 0.12rem 0.12rem 0 0;
  background: linear-gradient(90.04deg, rgba(238, 245, 255, 1) 0.05%, rgba(248, 251, 255, 0) 100.07%);
}

.branch_content {
  position: relative;
  width: 100%;
  padding: 0.24rem;
  border-radius: 0 0 0.12rem 0.12rem;
  border: 1px solid rgba(211, 213, 222, 1);
  box-sizing: border-box;
  background: rgba(255, 255, 255, 1);
}

.branch_type_list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.12rem;
}

.branch_type_item {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 0.76rem;
  color: rgba(102, 129, 250, 1);
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 0.28rem;
  border: 1px solid rgba(167, 183, 255, 1);
  border-radius: 0.60rem;
}

.branch_type_jt {
  width: 0.43rem;
  height: 0.18rem;
  background: url(../../assets/images/branch_jt.png) no-repeat;
  background-size: 100% 100%;
}

.branch_100 {
  width: 100%;
}

.branch_type_text {
  color: rgba(59, 69, 73, 1);
  font-family: PingFang SC;
  font-size: 0.28rem;
  line-height: 0.44rem;
  text-align: left;
  margin-top: 0.16rem;
}

.branch_type_c {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.2rem;
  height: 1.2rem;
  padding: 0 0.2rem;
  color: rgba(102, 129, 250, 1);
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 0.28rem;
  line-height: 0.32rem;
  border: 1px solid rgba(167, 183, 255, 1);
  border-radius: 50%;
}

.branch_yl {
  color: rgba(59, 69, 73, 1);
  font-family: PingFang SC;
  font-size: 0.28rem;
  line-height: 0.44rem;
  margin-bottom: 0.2rem;
  text-align: left;
}

.branch_yl span,
.branch_yjk span {
  color: rgba(102, 129, 250, 1);
  font-family: YouSheBiaoTiHei;
  font-size: 0.32rem;
  line-height: 0.44rem;
  font-weight: bold;
}

.branch_yjk {
  color: rgba(59, 69, 73, 1);
  font-family: PingFang SC;
  font-size: 0.28rem;
  line-height: 0.44rem;
  margin-bottom: 0.2rem;
  text-align: left;
}

.z_index9 {
  z-index: 101;
  margin-left: 0.1rem;
}

.score_tip_box {
  width: 6.1rem;
  left: -0.78rem;
  top: 0.6rem;
  ;
  padding: 0.24rem;
  color: rgba(59, 69, 73, 1);
  font-weight: 400;
  font-family: PingFang SC;
  font-size: 0.28rem;
  line-height: 0.44rem;
  border-radius: 0.12rem;
  box-shadow: 0.06rem 0.06rem 0.16rem rgba(47, 68, 87, 0.15);
  text-align: left;
}

.score_tip_span {
  display: block;
  font-weight: 500;
  color: rgba(59, 69, 73, 1);
  margin-top: 0.2rem;
}

.branch_wrap {
  padding: 0 0.24rem;
  margin-top: 0.24rem;

}

.branch_health_list {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .HEA1 {
    background-color: #3fd84520;
    color: #3fd845;
  }

  .HEA2 {
    background-color: #fecd1c20;
    color: #d2a60a;
  }

  .HEA3 {
    background-color: #ff494920;
    color: #ff4949;
  }

  .health-card {
    position: relative;
    width: 100%;
    padding: 0.18rem 0.3rem;
    font-weight: bold;
    text-align: left;

    >div {
      padding: 0.12rem 0;
    }

    .card-label {
      font-size: 0.28rem;
    }

    .card-value {
      font-size: 0.4rem;
    }
  }
}

.branch_health_item {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.1rem;
  height: 1.18rem;
  color: rgba(119, 127, 143, 1);
  font-family: PingFang SC;
  font-size: 0.3rem;
  border-radius: 0.08rem;
  // border: 1px solid rgba(211, 213, 222, 1);
  // background: url(../../assets/images/branch_health_3.png) no-repeat;
  background: url(../../assets/images/branch_health_bg.png) no-repeat;
  background-size: 99.9% 99.9%;
}

.branch_health_item_ca {
  font-size: 0.24rem;
}

.branch_health_1 {
  width: 2.1rem;
  height: 1.18rem;
  color: rgb(20, 203, 160);
  background: url(../../assets/images/branch_health_1.png) no-repeat;
  background-size: 100% 100%;
}

.branch_health_2 {
  width: 2.1rem;
  height: 1.18rem;
  color: rgb(245, 162, 0);
  background: url(../../assets/images/branch_health_2.png) no-repeat;
  background-size: 100% 100%;
}

.branch_health_3 {
  width: 2.1rem;
  height: 1.18rem;
  color: rgba(250, 102, 102, 1);
  background: url(../../assets/images/branch_health_3.png) no-repeat;
  background-size: 100% 100%;
}

.branch_health_item_text {
  flex: 1;
  color: rgba(59, 69, 73, 1);
  font-family: PingFang SC;
  font-size: 0.28rem;
  line-height: 0.28rem;
  margin-top: 0.2rem;
}

.branch_health_scale {
  transform: scale(1.12);
  font-weight: 500;
}

.score_val {
  font-family: Helvetica;
  font-weight: bold;
  font-size: 0.48rem;
}

.xiao_icon {
  width: 0.56rem;
  height: 0.48rem;
}

.score_color1 {
  color: rgb(20, 203, 160);
}

.score_color2 {
  color: rgb(254, 152, 0);
}

.score_color3 {
  color: rgb(250, 102, 102);
}

.sangao_text {
  width: 100%;
  background: rgba(245, 248, 254, 1);
  color: rgba(59, 69, 73, 1);
  font-family: PingFang SC;
  font-size: 0.28rem;
  line-height: 0.44rem;
  padding: 0.24rem;
  border-radius: 0.08rem;
  text-align: left;
}

.sel_cell {
  text-align: right;
  margin-top: 0.3rem;
}

.select_style {
  width: 3.2rem;
  height: 0.64rem;
  padding-left: 0.24rem;
  border-radius: 0.08rem;
  border: 1px solid rgba(211, 213, 222, 1);
  background-color: #fff;
}

.dl_bg {
  position: relative;
  width: 100%;
  height: 4.16rem;
  margin-top: 0.2rem;
  background: url(../../assets/images/dl1.png) no-repeat;
  background-size: 100% 100%;
}

.dl_bg2 {
  position: relative;
  width: 100%;
  height: 4.16rem;
  margin-top: 0.2rem;
  background: url(../../assets/images/dl2.png) no-repeat;
  background-size: 100% 100%;
}

.dl_bg3 {
  position: relative;
  width: 100%;
  height: 4.16rem;
  margin-top: 0.2rem;
  background: url(../../assets/images/dl3.png) no-repeat;
  background-size: 100% 100%;
}

.dl_bg4 {
  position: relative;
  width: 100%;
  height: 4.16rem;
  margin-top: 0.2rem;
  background: url(../../assets/images/dl4.png) no-repeat;
  background-size: 100% 100%;
}

.dl_bg5 {
  position: relative;
  width: 100%;
  height: 4.16rem;
  margin-top: 0.2rem;
  background: url(../../assets/images/dl5.png) no-repeat;
  background-size: 100% 100%;
}

.dl_bg6 {
  position: relative;
  width: 100%;
  height: 4.16rem;
  margin-top: 0.2rem;
  background: url(../../assets/images/dl6.png) no-repeat;
  background-size: 100% 100%;
}

.dl_bg7 {
  position: relative;
  width: 100%;
  height: 4.16rem;
  margin-top: 0.2rem;
  background: url(../../assets/images/dl7.png) no-repeat;
  background-size: 100% 100%;
}

.dl_bg8 {
  position: relative;
  width: 100%;
  height: 4.16rem;
  margin-top: 0.2rem;
  background: url(../../assets/images/dl8.png) no-repeat;
  background-size: 100% 100%;
}

.dl_bg9 {
  position: relative;
  width: 100%;
  height: 4.16rem;
  margin-top: 0.2rem;
  background: url(../../assets/images/dl9.png) no-repeat;
  background-size: 100% 100%;
}

.dl_bg10 {
  position: relative;
  width: 100%;
  height: 4.16rem;
  margin-top: 0.2rem;
  background: url(../../assets/images/dl10.png) no-repeat;
  background-size: 100% 100%;
}

.dl_bg11 {
  position: relative;
  width: 100%;
  height: 4.16rem;
  margin-top: 0.2rem;
  background: url(../../assets/images/dl11.png) no-repeat;
  background-size: 100% 100%;
}

.dl_bg12 {
  position: relative;
  width: 100%;
  height: 4.16rem;
  margin-top: 0.2rem;
  background: url(../../assets/images/dl12.png) no-repeat;
  background-size: 100% 100%;
}

.dl_bg13 {
  position: relative;
  width: 100%;
  height: 4.16rem;
  margin-top: 0.2rem;
  background: url(../../assets/images/dl13.png) no-repeat;
  background-size: 100% 100%;
}

.dl_bg14 {
  position: relative;
  width: 100%;
  height: 4.16rem;
  margin-top: 0.2rem;
  background: url(../../assets/images/dl14.png) no-repeat;
  background-size: 100% 100%;
}

.dl_bg15 {
  position: relative;
  width: 100%;
  height: 4.16rem;
  margin-top: 0.2rem;
  background: url(../../assets/images/dl15.png) no-repeat;
  background-size: 100% 100%;
}

.dl_bg16 {
  position: relative;
  width: 100%;
  height: 4.16rem;
  margin-top: 0.2rem;
  background: url(../../assets/images/dl16.png) no-repeat;
  background-size: 100% 100%;
}

.medical_dl_bg {
  position: relative;
  width: 100%;
  height: 3.44rem;
  margin-top: 0.2rem;
  background: url(../../assets/images/medical_dl.png) no-repeat;
  background-size: 100% 100%;
}

.medical_dl_bg2 {
  position: relative;
  width: 100%;
  height: 3.44rem;
  margin-top: 0.2rem;
  background: url(../../assets/images/medical_dl2.png) no-repeat;
  background-size: 100% 100%;
}

.medical_dl_bg3 {
  position: relative;
  width: 100%;
  height: 3.44rem;
  margin-top: 0.2rem;
  background: url(../../assets/images/medical_dl3.png) no-repeat;
  background-size: 100% 100%;
}

.medical_dl_bg4 {
  position: relative;
  width: 100%;
  height: 3.44rem;
  margin-top: 0.2rem;
  background: url(../../assets/images/medical_dl4.png) no-repeat;
  background-size: 100% 100%;
}

.injury_dl_bg {
  position: relative;
  width: 100%;
  height: 3.44rem;
  margin-top: 0.2rem;
  background: url(../../assets/images/death_dl.png) no-repeat;
  background-size: 100% 100%;
}

.injury_dl_bg2 {
  position: relative;
  width: 100%;
  height: 3.44rem;
  margin-top: 0.2rem;
  background: url(../../assets/images/injury_dl.png) no-repeat;
  background-size: 100% 100%;
}

.dl_catg {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0.2rem;
}

.dl_catg_m {
  position: relative;
  color: rgba(59, 69, 73, 1);
  font-family: PingFang SC;
  font-size: 0.22rem;
  line-height: 0.24rem;
}

.dl_catg_wm {
  position: relative;
  color: rgba(59, 69, 73, 1);
  font-family: PingFang SC;
  font-size: 0.22rem;
  line-height: 0.24rem;
  margin-right: 0.8rem;
}

.dl_catg_h {
  position: relative;
  color: rgba(59, 69, 73, 1);
  font-family: PingFang SC;
  font-size: 0.22rem;
  line-height: 0.24rem;
  margin-left: 0.8rem;
}

.dl_catg_m::before {
  content: '';
  position: absolute;
  top: 0.1rem;
  left: -0.3rem;
  width: 0.23rem;
  height: 0.02rem;
  background-color: rgba(91, 155, 213, 1);
}

.dl_catg_wm::before {
  content: '';
  position: absolute;
  top: 0.1rem;
  left: -0.3rem;
  width: 0.23rem;
  height: 0.02rem;
  background-color: rgba(237, 125, 49, 1);
}

.dl_catg_h::before {
  content: '';
  position: absolute;
  top: 0.1rem;
  left: -0.3rem;
  width: 0.23rem;
  height: 0.02rem;
  background-color: #a8a8a8;
}

.dl_bg_line {
  position: absolute;
  width: 0.02rem;
  height: 4.16rem;
  background-color: rgba(211, 213, 222, 1);
}

.medical_dl_bg_line {
  position: absolute;
  width: 0.02rem;
  height: 3.44rem;
  background-color: rgba(211, 213, 222, 1);
}

.dl_bg_tip {
  position: absolute;
  top: 60%;
  left: -0.7rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.44rem;
  height: 0.72rem;
  border-radius: 0.08rem;
  color: rgba(87, 93, 105, 1);
  font-family: PingFang SC;
  font-size: 0.24rem;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0.02rem 0.02rem 0.08rem rgba(79, 92, 139, 0.25);
}

.dl_bg_tip span {
  position: relative;
  z-index: 9;
}

.to_update {
  position: absolute;
  right: 0.24rem;
  top: 0.24rem;
  color: rgba(87, 93, 105, 1);
  font-family: PingFang SC;
  font-size: 0.24rem;
  line-height: 0.24rem;
}

.text_left {
  text-align: left;
}

.text_right {
  text-align: right;
}

.body_item {
  width: 100%;
  padding: 0.24rem 0.28rem;
  border-radius: 0.16rem;
  background: rgba(255, 255, 255, 1);
  margin-bottom: 0.16rem;
}

.body_item_title {
  color: rgba(50, 54, 62, 1);
  font-family: PingFang SC;
  font-weight: 600;
  font-size: 0.32rem;
  margin-bottom: 0.2rem;
}

.body_item_val {
  color: rgba(50, 54, 62, 1);
  font-family: PingFang SC;
  font-size: 0.24rem;
  font-weight: 400;
}

.body_item_val span {
  color: rgba(50, 54, 62, 1);
  font-family: MiSans-Demibold;
  font-size: 0.32rem;
  font-weight: 500;
}

.body_item_group {
  color: rgba(50, 54, 62, 1);
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 0.24rem;
}

.body_item_group span {
  color: rgba(50, 54, 62, 1);
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 0.32rem;
}

.body_item_group_db {
  color: rgba(50, 54, 62, 1);
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 0.24rem;
  margin-top: 0.08rem;
}

.body_item_group_db span {
  display: inline-block;
  // color: rgba(239, 143, 0, 1);
  font-family: PingFang SC;
  font-weight: bold;
  font-size: 0.24rem;
  border-radius: 0.08rem;
  padding: 0.04rem 0.12rem;
}

.group_di {
  color: rgba(239, 143, 0, 1) !important;
  background: rgba(255, 233, 163, 1) !important;
}

.group_zhong {
  color: rgba(35, 203, 41, 1) !important;
  background-color: rgba(213, 244, 214, 1) !important;
}

.group_gao {
  color: rgba(239, 143, 0, 1) !important;
  background: rgba(255, 233, 163, 1) !important;
}

.body_item_oth {
  width: 100%;
  padding: 0.24rem 0.18rem 0.24rem 0.28rem;
  border-radius: 0.16rem;
  background: rgba(255, 255, 255, 1);
  margin-bottom: 0.16rem;
}

.body_item_oth .body_item_group {
  margin-top: 0.11rem;
  font-size: 0.28rem;
}

.body_item_oth .body_item_val {
  margin-top: 0.08rem;
  font-size: 0.28rem;
}

.body_item_oth_val {
  color: rgba(102, 129, 250, 1);
  font-family: MiSans-Demibold;
  font-size: 0.4rem;
  line-height: 0.4rem;
  font-weight: bold;
  margin-top: 0.24rem;
  margin-bottom: 0.28rem;
}

.body_item_oth .body_item_val span {
  display: inline-block;
  // color: rgba(239, 143, 0, 1);
  font-family: PingFang SC;
  font-weight: bold;
  font-size: 0.24rem;
  border-radius: 0.08rem;
  padding: 0.04rem 0.12rem;
  margin-left: 0.08rem;
}

.body_item_oth p {
  color: rgba(140, 145, 154, 1);
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 0.28rem;
  line-height: 0.44rem;
}


.body_echat {
  display: flex;
  align-items: center;
  margin-top: 0.48rem;
  padding-bottom: 0.3rem;
  margin-bottom: 0.4rem;
  border-bottom: 1px solid rgba(245, 246, 250, 1);
}

.body_echat_title {
  color: rgba(50, 54, 62, 1);
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 0.24rem;
  margin-right: 0.3rem;
}

.line {
  position: relative;
  display: flex;
  align-items: center;
}

.biaoqian_box {
  position: absolute;
  top: -0.02rem;
  left: 0;
  z-index: 9;
}

.biaoqian {
  width: 0.16rem;
  height: 0.25rem;
  // transform: rotate(90deg);
}

// .line::after {
// 	position: absolute;
// 	content: '';
// 	top: -0.1rem;
// 	left: 20%;
// 	width: 0.22rem;
// 	height: 0.12rem;
// 	background: url(../../assets/images/biaoqian.png) no-repeat;
// 	background-size: 100% 100%;
// 	transform: rotate(90deg);
// }
.line_item {
  position: relative;
  width: 1.52rem;
  height: 0.12rem;
  border-radius: 0.06rem;
}

.whr_wrap .line_item {
  width: 2.28rem;
}

.body_val_text {
  position: relative;
  top: 0.10rem;
  right: -0.16rem;
  text-align: right;
  color: rgba(50, 54, 62, 1);
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 0.24rem;
}

.line_di {
  background-color: rgba(244, 205, 64, 1);
}

.line_zhong {
  background-color: rgba(63, 216, 69, 1);
}

.line_gao {
  background-color: rgba(255, 92, 92, 1);
}

.body_val_di {
  color: rgba(239, 143, 0, 1);
  background-color: rgba(255, 233, 163, 1);
}

.body_val_zhong {
  color: rgba(35, 203, 41, 1);
  background-color: rgba(213, 244, 214, 1);
}

.body_val_gao {
  color: rgba(250, 81, 81, 1);
  background-color: rgba(255, 199, 199, 1);
}

.body_echat_val {
  position: absolute;
  top: -0.64rem;
  left: 0;
  color: rgba(50, 54, 62, 1);
  font-family: MiSans-Demibold;
  font-size: 0.32rem;
  font-weight: bold;
  display: flex;
  align-items: center;
}

.body_echat_val span {
  display: inline-block;
  padding: 0.04rem 0.12rem;
  font-family: PingFang SC;
  font-weight: bold;
  font-size: 0.24rem;
  border-radius: 0.08rem;
  margin-left: 0.08rem;
}

.costs_top {
  position: relative;
  color: rgba(41, 48, 51, 1);
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 0.36rem;
  line-height: 0.36rem;
  text-align: left;
  margin-bottom: 0.24rem;
}

.costs_top::before {
  content: '';
  position: absolute;
  top: 0.12rem;
  left: -0.24rem;
  width: 0.16rem;
  height: 0.12rem;
  border-radius: 0 0.04rem 0.04rem 0;
  background: rgba(104, 131, 251, 1);
}

.costs_top .bomi_btn_cell {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1,
}

.bomi_btn_cell .bomi_v_btn {
  padding: 0 0.1rem;
  font-size: 0.18rem;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #6883FB;
  border-radius: 0.04rem;
  border: 0.01rem solid #6883FB;
}

.bomi_btn_cell .bomi_g_btn {
  padding: 0 0.1rem;
  font-size: 0.18rem;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #6883FB;
  border-radius: 0.04rem;
  border: 0.01rem solid #6883FB;
  margin-left: 0.08rem;
}

.bomi_btn_cell .bomi_btn_active {
  background-color: #6883FB;
  color: #fff;
}

.bomi_btn_box {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.margin-top-48 {
  margin-top: 0.48rem;
}

.biom-chart_bottom {
  position: relative;
  color: rgba(59, 69, 73, 1);
  font-family: PingFang SC;
  font-size: 0.26rem;
  line-height: 0.34rem;
  padding-left: 1.4rem;
  background-color: #F5F8FC;
}

.biom-chart_bottom::before {
  content: '';
  position: absolute;
  top: 0.08rem;
  left: 1.1rem;
  width: 0.16rem;
  height: 0.16rem;
  border-radius: 0.04rem;
  background-color: rgba(255, 91, 91, 1);

}

.biom-chart_bottom2 {
  position: relative;
  color: rgba(59, 69, 73, 1);
  font-family: PingFang SC;
  font-size: 0.26rem;
  line-height: 0.34rem;
  padding-left: 1.4rem;
  background-color: #F5F8FC;
  padding-bottom: 0.2rem;
  padding-top: 0.08rem;
  border-radius: 0 0 0.08rem 0.08rem;
}

.biom-chart_bottom2::before {
  content: '';
  position: absolute;
  top: 0.16rem;
  left: 1.1rem;
  width: 0.16rem;
  height: 0.16rem;
  border-radius: 0.04rem;
  background-color: rgba(255, 204, 26, 1);

}

.m14_t {
  width: 1.4rem;
}

.m14_v {
  flex: 1;
}

.m14_l {
  width: 1.2rem;
  text-align: right;
}

.new_bmi {
  margin-bottom: 0.3rem;
}

.new_bmi_p {
  margin-top: 0.2rem;
  line-height: 0.38rem;
}

.new_bmi_val,
.new_bmi_b,
.new_bmi_p_v,
.new_bmi_p_v2,
.new_bmi_lx {
  font-size: 0.3rem;
  color: #40444D;
  font-weight: 500;
}

.improve_c0 {
  color: rgb(254, 152, 0) !important;
}

.eat b {
  color: #6883FB !important;
}


.weight_chart {
  width: 100%;
  height: 4rem;
}

.whr_chart {
  width: 100%;
  height: 4rem;
}

.weight_chart_title {
  font-size: 14px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 400;
  color: #40444D;
  line-height: 18px;
  margin-top: 12px;
}
</style>
